<template>
    <div class="inner-wrapper" v-if="order">
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
        </div>

        <div
            v-if="commonErrors.length != 0"
            class="alert alert-danger alert-dismissible"
        >
            <a href="#" class="close" data-dismiss="alert" aria-label="close"
                >&times;</a
            >
            <ul>
                <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                    </p>
                </li>
            </ul>
        </div>

        <!--<div v-if="validationErrors && validationErrors.errors">
            {{validationErrors.errors | JSON}}
            <ul>
                <li v-for="(v, k) in validationErrors.errors" :key="k">
                    {{k}}
                    <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                    </p>
                </li>
            </ul>
        </div>-->

        <!-- <div
            class="alert alert-danger alert-dismissible"
            v-if="dueTasks && dueTasks.length"
        > -->
        <!-- <template v-if="dueTasks && dueTasks.length">
            
           
             <template v-for="(task, index) in dueTasks">
                <template
                    v-if="
                        compareString(task.title, 'Create Purchase Order') ||
                        compareString(
                            task.title,
                            'Create PO on remaining items'
                        )
                    "
                >
                    <template
                        v-if="
                            (getUser != null && getUser.user_type == 1) ||
                            hasRole('Admin') ||
                            hasPerm('add-purchase-order')
                        "
                    >


                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                        <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="goToCreatePO"
                        >Create PO</a
                    >
                    </div>
                     <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    
                </div>

                        
                    </template>
                    <template v-else> 
                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                        
                    </div>
                     <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>
                    </template>
                </template>
                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Send Sales Order to customer'
                        )
                    "
                >

                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                        <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        data-toggle="modal"
                        data-target="#sendToCustomerModal"
                        >Send to Customer</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                </template>
                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Receive artwork and send to vendor'
                        ) ||
                        compareString(
                            task.title,
                            'Receive proof and send to customer'
                        ) ||
                        compareString(
                            task.title,
                            'send/receive rest of the artwork'
                        )
                    "
                >
                    <template v-if="order.is_no_artwork == 0">

                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="artworkSampleRequiredEvent()"
                            >Artworks</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>
                        
                    </template>

                    <template
                        v-if="
                            compareString(
                                task.title,
                                'Receive artwork and send to vendor'
                            )
                        "
                    >
                    
                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="completeTask(task.id)"
                            >Complete</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>
                    
                    </template>
                    <template
                        v-if="
                            compareString(
                                task.title,
                                'Receive proof and send to customer'
                            )
                        "
                    >

                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="completeTask(task.id)"
                            >Artwork Approved</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>

                       
                    </template>
                </template>
                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Get a ready date and set a follow up date'
                        )
                    "
                >

                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="openGetAReadyDate(task, 'eta')"
                            >Deposit Sent</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>

                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Customer should confirm SO')
                    "
                >
                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="completeTask(task.id)"
                            >Confirmed</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>

                    
                </template>
                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Customer to approve the artwork'
                        ) ||
                        compareString(
                            task.title,
                            'Customer to approve updated proof'
                        )
                    "
                >

                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                        <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="completeTask(task.id)"
                        >Artwork Approved</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                </template>
                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Send updated proof to customer '
                        )
                    "
                >
                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="completeTask(task.id)"
                            >Updated proof</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>

                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Proceed with production')
                    "
                >
                    
                    <template>
                        <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                            <div class="df-wrap-center">
                                <span>{{ task.title }}</span> 
                                <a
                                href="javascript:void(0);"
                                class="btn btn-primary btn-sm ms-1"
                                @click="completeTask(task.id)"
                                >Proceed</a>
                            </div>
                            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        </div>

                        
                    </template>
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Send deposit for vendor')
                    "
                >
                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="completeTask(task.id)"
                            >Deposit Sent</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>
                   
                </template>
                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Receive deposit from customer'
                        )
                    "
                >
                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="completeTask(task.id)"
                            >Deposit Received</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>

                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Customer to approve sample')
                    "
                >
                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="completeTask(task.id)"
                            >Sample Approved</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>

                    
                </template>
                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Check if air freight is needed'
                        )
                    "
                >
                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                        <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="openCreateShipment(true)"
                        >Create Air Shipment</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                </template>
                <template
                    v-else-if="compareString(task.title, 'Create Air Shipment')"
                >
                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="openCreateShipment(true)"
                            >Create Air Shipment</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>

                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Create shipment') ||
                        compareString(task.title, 'Ship remaining items')
                    "
                >

                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="openCreateShipment(true)"
                            >Create Shipment</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>
                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Factory to ship sample')
                    "
                >

                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                        
                    <span class="line-label">Tracking</span>
                    <input
                            style="width: 70px"
                            type="text"
                            v-model="order.sample_tracking_no"
                            placeholder=""
                            class="form-control form-control-sm ms-1"
                    />
                    <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="sampleShipped(task)"
                            >Sample shipped</a
                        >
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                </template>
                <template v-else>
                
                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                        
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>
                </template>
           
            </template>
        </template>

        <template v-if="order.purchase_orders && order.purchase_orders.length">
            <template v-for="item in order.purchase_orders">
                <div
                    class="error mb-3"
                    v-if="
                        item.eta &&
                        item.follow_up &&
                        !item.is_ready_date_confirmed
                    "
                >
                    Factory Ready Date: {{ formatDate(item.eta) }} Follow up
                    Date: {{ formatDate(item.follow_up) }}
                </div>
            </template>
        </template>

        <template
            v-if="
                poWithTasks &&
                poWithTasks.length &&
                poWithTasks.filter(
                    (x) =>
                        x.tasks &&
                        x.tasks.filter((task) =>
                            compareString(task.title, 'Proceed with production')
                        ).length
                ).length
            "
        >
            <div class="error mb-3">Proceed with production</div>
        </template> -->


        <div class="card track-card">
            <div class="card-body">
                <div class="w-100 d-flex align-items-center">
                    <span style="font-weight:bold;">Order # <span style="color:#303c66;">{{ order.order_number }}</span></span>
                    <ul class="progressbar mb-0 ps-0 flex-grow-1">
                        <li 
                        :class="{
                                done: order.so_status_id == 1,
                                done: order.so_status_id > 1,
                            }"
                        ><span>Open</span></li>
                        <li 
                        :class="{
                                done: order.so_status_id == 2,
                                done: order.so_status_id > 2,
                            }"
                        ><span>Send to customer</span></li>
                        <li 
                        :class="{
                                done: [3, 4, 5, 6, 7].includes(
                                    order.so_status_id
                                ),
                                done: order.so_status_id >= 7,
                            }"
                        ><span>Artwork/Sample Approval</span></li>
                        <li 
                         :class="{
                                done: order.so_status_id == 8,
                                done: order.so_status_id > 8,
                            }"
                        
                        ><span>In production</span>
                        <template v-if="isPartial"
                                    ><div class="error">
                                        Partially
                                    </div></template
                                >
                        </li>
                        <li :class="{
                                done: [10, 12].includes(order.so_status_id),
                                done: [9, 11, 12].includes(
                                    order.so_status_id
                                ),
                            }"><span>Pending shipping</span></li>
                        <li
                        :class="{
                                done: [9, 11].includes(order.so_status_id),
                                done: order.so_status_id == 11,
                            }"
                        ><span>Shipped</span></li>
                        <!-- <li><span>Shipped/Partially</span></li>
                        <li><span>Delivered</span></li> -->
                    </ul>
                    <div class="dropdown notesectioncl ms-3">

                    <template v-if="order.is_draft != 1">
                            

                            <div
                                class="btn-group customdropdown pull-right ms-1"
                            >
                                <button
                                    type="button"
                                    class="btn btn-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style="
                                        padding: 0.3rem 0.65rem;
                                        font-size: 1.1rem;
                                    "
                                >
                                    <i
                                        class="ri-settings-4-fill align-bottom"
                                    ></i>
                                </button>
                                <div class="dropdown-menu">

                                    <!-- <a
                                        
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        data-toggle="modal"
                                        data-target="#sendToCustomerModal"
                                        ><i class="ri-sticky-note-line pe-1 align-middle"></i> Send to Customer</a
                                    > -->
                                    
                                    <a
                                        href="javascript:void(0);"
                                        class="dropdown-item"
                                        data-toggle="modal"
                                        data-target="#notesModal"
                                        ><i class="ri-sticky-note-line pe-1 align-middle"></i> Notes</a
                                    >

                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        data-toggle="modal"
                                        data-target="#actionLogModal"
                                        ><i
                                            class="ri-history-line pe-1 align-middle"
                                        ></i>
                                        History</a
                                    >

                                    <a
                                        
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        data-toggle="modal"
                                        data-target="#sendToCustomerModal"
                                        ><i class="fas fa-paper-plane"></i> Send
                                        to Customer</a
                                    >

                                    <a
                                        
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        
                                        ><i
                                            class="ri-truck-line pe-1 align-middle"
                                        ></i> Create Shipments</a
                                    >
                                    <a
                                        
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        
                                        ><i
                                            class="ri-truck-line pe-1 align-middle"
                                        ></i> Create Invoice</a
                                    >


                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        v-on:click="copySoOrder()"
                                        ><i
                                            class="ri-file-copy-2-line pe-1 align-middle"
                                        ></i>
                                        Copy Order</a
                                    >

                                    <a
                                        v-if="
                                            (getUser != null &&
                                                getUser.user_type == 1) ||
                                            hasRole('Admin') ||
                                            hasPerm('add-purchase-order')
                                        "
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        v-on:click="createPO"
                                        ><i
                                            class="ri-add-box-line pe-1 align-middle"
                                        ></i>
                                        Create PO</a
                                    >
                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        v-on:click="downloadPdf"
                                        ><i
                                            class="ri-download-2-line pe-1 align-middle"
                                        ></i>
                                        Download</a
                                    >
                                    
                                </div>
                            </div>
                        </template>

                        
                    </div>
                </div>
            </div>
        </div>
        

        <ValidationObserver v-slot="{ handleSubmit }" ref="orderFormValidation">
            <!--<form @submit.prevent="handleSubmit(submitHandler)" enctype="multipart/form-data">-->
            <form @submit.prevent="submitHandler" enctype="multipart/form-data">
                
                <div class="row cus-col">
                            <div class="col-xl-9 col-xxl-10">
                                <div class="card custom-card">
                                    <div class="card-body py-25">
                                        <div class="mb-2 mt-0 d-flex justify-content-end align-items-end">
                                            <a href="javascript: void(0);" class="rtn-edit" data-toggle="modal" data-target="#editSalesOrderDetailsModal"><i class="ri-edit-fill me-1"></i> Edit</a>
                                        </div>
                                        <div class="row g-0 new-des-status">

                                        <!-- <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item rounded-left-top-bottom border border-solid border-start w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Order Number:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{
                                                order.order_number
                                                    ? order.order_number
                                                    : ""
                                            }}</p>
                                                </div>
                                            </div> -->
                                            
                                            <!--end col-->

                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item rounded-left-top-bottom border border-solid border-start w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Quote Number:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">
                                                        
                                                        <template v-if="order.quote_num != null">{{ order.quote_num }}</template>
                                                        <template v-else="orderQuotes.length > 0">
                                                            <template  v-for="(
                                                                quote, index
                                                            ) in orderQuotes">
                                                            {{  quote.quotation_number}}
                                                            </template>
                                                        </template>
                                                        
                                                        
                                                    <!-- {{
                                                order.quote
                                                    ? order.quote.quotation_number
                                                    : ""
                                            }} -->
                                            
                                            </p>
                                                </div>
                                            </div><!--end col-->

                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item rounded-left-top-bottom border border-solid border-start w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Status:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{
                                                order.order_status
                                                    ? order.order_status.name
                                                    : ""
                                            }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Sales Rep:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc"> {{
                                                order.sales_rep
                                                    ? order.sales_rep.name
                                                    : ""
                                            }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Created:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{ order.order_date }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Customer PO:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{ order.customer_po }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Customer Terms:</p>
                                                    <div class="view-content" v-html="order.customer_terms"></div>
                                                    <!-- <p class="text-muted fs-14 mb-0 hd-desc">Lorem ipsum</p> -->
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Planned Delivery Date:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{ order.eta }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Created By :</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{ order.added_by ? order.added_by.name : "" }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">FOB:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{ order.fob }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <!-- <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item rounded-right-top-bottom border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Added by:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">Devid John</p>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>

                                    <div class="custom-block">
                                        <ul class="nav nav-pills nav-light mb-0 ms-3" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" data-toggle="tab" href="#arrow-overview" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-stack-line"></i></span>
                                                    <span class="d-none d-sm-block">Products</span> 
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-attach" ref="artworkRef" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-attachment-2"></i></span>
                                                    <span class="d-none d-sm-block">Artworks/Attachments</span> 
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-purchase" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-home-5-line"></i></span>
                                                    <span class="d-none d-sm-block"> Purchase Order</span> 
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-shipment" ref="shipmentRef" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-file-text-line"></i></span>
                                                    <span class="d-none d-sm-block"> Shipments</span>   
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-invoice" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-shopping-cart-line"></i></span>
                                                    <span class="d-none d-sm-block"> Invoice</span>   
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-quotes" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-shopping-cart-line"></i></span>
                                                    <span class="d-none d-sm-block"> Quotes</span>   
                                                </a>
                                            </li>
                                        </ul>
                                        <!-- Tab panes -->
                                        <div class="tab-content card-body text-muted">
                                            <div class="d-flex justify-content-end">
                                                <a href="javascript: void(0);"
                                                v-if="
                                                    !isEditMode &&
                                                    ((getUser != null &&
                                                        getUser.user_type == 1) ||
                                                        hasRole('Admin') ||
                                                        hasPerm('edit-purchase-order'))
                                                "
                                                 v-on:click="changeEditMode(true)"
                                                 style="margin-top: -5px;" class="rtn-edit mb-2 fshe" id="edit"><i class="ri-edit-fill me-1"></i> Edit</a>
                                                <div class="mb-2 text-end she" style="margin-top: -5px;">
                                                    <button class="btn btn-sm btn-danger me-1" id="edit-cancel"  v-if="isEditMode" 
                                                    @click="isEditMode = false; getOrder();">Cancel</button>
                                                    <button class="btn btn-sm btn-primary"
                                                    v-if="isEditMode"
                                                    type="submit"
                                                    :disabled="loading"
                                                    >Save Now</button>
                                                </div>
                                            </div>  
                                            <div class="tab-pane active" id="arrow-overview" role="tabpanel">
                                                <div class="table-responsive table-card mt-0 m-0">
                                                    <table class="table table-bordered align-middle mb-0">
                                                        <thead class="table-light text-muted">
                                                            <tr>
                                                            <th
                                                                style="
                                                                    width: 20px;
                                                                "
                                                                v-if="
                                                                    isEditMode
                                                                "
                                                            ></th>
                                                            <th
                                                                style="
                                                                    width: 140px;
                                                                "
                                                            >
                                                                Item Number
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 30%;
                                                                "
                                                            >
                                                                Product name
                                                                &amp;
                                                                Description
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 75px;
                                                                "
                                                            >
                                                                Quantity
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 75px;
                                                                "
                                                            >
                                                                UOM
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 75px;
                                                                "
                                                            >
                                                                Unit Price
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 75px;
                                                                "
                                                            >
                                                                Total
                                                            </th>
                                                            <!--<th style="width: 75px;">Art Status</th>-->
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                Shipped Quantity
                                                            </th>
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                Artwork Status
                                                            </th>
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                Vendor
                                                            </th>
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                Product Status
                                                            </th>
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                PO Number
                                                            </th>
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                Profit
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 50px;
                                                                "
                                                            >
                                                                <div
                                                                    class="d-flex"
                                                                >
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        v-if="
                                                                            !productExtendedView
                                                                        "
                                                                        @click="
                                                                            productExtendedView = true
                                                                        "
                                                                        >Expand</a
                                                                    >
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        v-if="
                                                                            productExtendedView
                                                                        "
                                                                        @click="
                                                                            productExtendedView = false
                                                                        "
                                                                        >Hide</a
                                                                    >
                                                                </div>
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        
                                                        
                                                            <draggable
                                                        v-model="order.products"
                                                        :disabled="!isEditMode"
                                                        element="tbody"
                                                        @change="
                                                            handleSortChange(
                                                                $event
                                                            )
                                                        "
                                                    >
                                                        <tr
                                                            v-for="(
                                                                product, index
                                                            ) in order.products"
                                                            :key="index"
                                                            :id="product.id"
                                                            class="dragndrop"
                                                        >
                                                            <td
                                                                v-if="
                                                                    isEditMode
                                                                "
                                                            >
                                                                <span
                                                                    class="movebtn"
                                                                    ><i
                                                                        class="fas fa-arrows-alt"
                                                                    ></i
                                                                ></span>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                    type="text"
                                                                    class="form-control"
                                                                    placeholder="Item#"
                                                                    v-model="
                                                                        order
                                                                            .products[
                                                                            index
                                                                        ]
                                                                            .product_num
                                                                    "
                                                                />
                                                                <template
                                                                    v-if="
                                                                        !isEditMode
                                                                    "
                                                                >
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'productsDetails',
                                                                            params: {
                                                                                id: order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .product_id,
                                                                            },
                                                                        }"
                                                                        title="Item Detail"
                                                                        target="_blank"
                                                                    >
                                                                        {{
                                                                            product.product_num
                                                                        }}
                                                                    </router-link>
                                                                    <template v-if="product.product">
                                                                        <p v-if="product.product.customer_sku">
                                                                        Customer SKU: {{
                                                                          product.product ?  product.product.customer_sku : ""
                                                                        }}
                                                                        </p>
                                                                        
                                                                        
                                                                        </template>
                                                                </template>
                                                            </td>
                                                            <td>
                                                                <ValidationProvider
                                                                    name="Product Name"
                                                                    rules="required"
                                                                    v-slot="{
                                                                        errors,
                                                                    }"
                                                                >
                                                                    <input
                                                                        v-if="
                                                                            isEditMode
                                                                        "
                                                                        v-model="
                                                                            order
                                                                                .products[
                                                                                index
                                                                            ]
                                                                                .product_name
                                                                        "
                                                                        type="text"
                                                                        class="form-control form-custom mb-1"
                                                                        placeholder=""
                                                                    />
                                                                    <div
                                                                        class="error"
                                                                        v-if="
                                                                            errors.length
                                                                        "
                                                                    >
                                                                        {{
                                                                            errors[0]
                                                                        }}
                                                                    </div>
                                                                </ValidationProvider>
                                                                <ckeditor
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                    v-model="
                                                                        order
                                                                            .products[
                                                                            index
                                                                        ]
                                                                            .product_desc
                                                                    "
                                                                    type="inline"
                                                                    :config="
                                                                        editorConfigMin
                                                                    "
                                                                ></ckeditor>

                                                                <template
                                                                    v-if="
                                                                        !isEditMode
                                                                    "
                                                                >
                                                                    <p>
                                                                        {{
                                                                            product.product_name
                                                                        }}
                                                                    </p>
                                                                    <p
                                                                        v-html="
                                                                            product.product_desc
                                                                        "
                                                                    ></p>
                                                                </template>

                                                                <div
                                                                    class="form-check confirm-modify"
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <label
                                                                        class="form-check-label"
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .is_update_master_product
                                                                            "
                                                                            class="form-check-input"
                                                                            value="1"
                                                                        />
                                                                        Do you
                                                                        want to
                                                                        modify
                                                                        the
                                                                        master
                                                                        product?
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Quantity"
                                                                        immediate
                                                                        rules="required|positive|min_value:0"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                        <input
                                                                            type="text"
                                                                            class="form-control form-custom"
                                                                            placeholder=""
                                                                            v-on:keydown="
                                                                                checkNumber(
                                                                                    $event
                                                                                )
                                                                            "
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .quantity
                                                                            "
                                                                        />
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                    {{
                                                                        product.quantity
                                                                    }}
                                                                </template>
                                                            </td>
                                                            <td>
                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Quantity unit"
                                                                        rules="required"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                        <select
                                                                            class="form-control"
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .qty_unit_id
                                                                            "
                                                                        >
                                                                            <option
                                                                                value=""
                                                                            >
                                                                                Select
                                                                            </option>
                                                                            <option
                                                                                v-for="(
                                                                                    qtyUnit,
                                                                                    unitIndex
                                                                                ) in quantityUnits"
                                                                                :value="
                                                                                    qtyUnit.id
                                                                                "
                                                                            >
                                                                                {{
                                                                                    qtyUnit.name
                                                                                }}
                                                                            </option>
                                                                        </select>
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                    {{
                                                                        product.qty_unit
                                                                            ? product
                                                                                  .qty_unit
                                                                                  .name
                                                                            : ""
                                                                    }}
                                                                </template>
                                                            </td>
                                                            <td>
                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Price"
                                                                        rules="required|positive|min_value:0"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                        <input
                                                                            type="text"
                                                                            class="form-control form-custom dollar-prefix"
                                                                            placeholder=""
                                                                            v-on:keydown="
                                                                                checkDecimal(
                                                                                    $event,
                                                                                    this
                                                                                )
                                                                            "
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .price
                                                                            "
                                                                        />
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                    ${{
                                                                        numberWithCommas(
                                                                            product.price
                                                                        )
                                                                    }}
                                                                </template>
                                                            </td>

                                                            <td>
                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Cost"
                                                                        rules="required|positive|min_value:0"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                        <input
                                                                            type="text"
                                                                            class="form-control form-custom dollar-prefix"
                                                                            placeholder=""
                                                                            v-on:keydown="
                                                                                checkDecimal(
                                                                                    $event,
                                                                                    this
                                                                                )
                                                                            "
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .cost
                                                                            "
                                                                        />
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                    ${{
                                                                        numberWithCommas(
                                                                            product.cost.toFixed(
                                                                                2
                                                                            )
                                                                        )
                                                                    }}
                                                                </template>
                                                            </td>
                                                            <!--<td>
                                                                <a href="javascript:void(0)"
                                                                   v-on:click="openProductArtworksModal(product)">
                                                                    <template
                                                                        v-if="product.latest_artwork && product.latest_artwork.artwork_status_id == 8">
                                                                        Yes
                                                                    </template>
                                                                    <template v-else>No</template>
                                                                </a>
                                                            </td>-->
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >{{ getTotalShippingQty(product) }}
                                                                <!-- <template
                                                                    v-if="
                                                                        product.quote_product &&
                                                                        product
                                                                            .quote_product
                                                                            .quotation
                                                                    "
                                                                >
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'viewQuote',
                                                                            params: {
                                                                                id: product
                                                                                    .quote_product
                                                                                    .quotation
                                                                                    .id,
                                                                            },
                                                                        }"
                                                                        target="_blank"
                                                                    >
                                                                        #{{
                                                                            product
                                                                                .quote_product
                                                                                .quotation
                                                                                .quotation_number
                                                                        }}
                                                                    </router-link>
                                                                </template> -->
                                                            </td>
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                <div
                                                                    v-for="art in product.artworks"
                                                                >
                                                                    V-{{
                                                                        art.version_number
                                                                    }}:
                                                                    {{
                                                                        art.artwork_status
                                                                            ? art
                                                                                  .artwork_status
                                                                                  .name
                                                                            : null
                                                                    }}
                                                                </div>
                                                            </td>
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                <template
                                                                    v-if="
                                                                        product.purchase_order_products.filter(
                                                                            (
                                                                                x
                                                                            ) =>
                                                                                x.purchase_order &&
                                                                                x
                                                                                    .purchase_order
                                                                                    .vendor
                                                                        ).length
                                                                    "
                                                                >
                                                                    <template
                                                                        v-for="po_product in product.purchase_order_products.filter(
                                                                            (
                                                                                x
                                                                            ) =>
                                                                                x.purchase_order &&
                                                                                x
                                                                                    .purchase_order
                                                                                    .vendor
                                                                        )"
                                                                    >
                                                                        <router-link
                                                                            :to="{
                                                                                name: 'vendorDetails',
                                                                                params: {
                                                                                    id: po_product
                                                                                        .purchase_order
                                                                                        .vendor_id,
                                                                                },
                                                                            }"
                                                                            target="_blank"
                                                                        >
                                                                            {{
                                                                                po_product
                                                                                    .purchase_order
                                                                                    .vendor
                                                                                    .company_name
                                                                            }}
                                                                        </router-link>
                                                                    </template>
                                                                </template>
                                                                <template v-else
                                                                    >Not on a
                                                                    PO</template
                                                                >
                                                            </td>
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                {{
                                                                    product.status
                                                                }}
                                                            </td>
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                <template
                                                                    v-for="(
                                                                        po,
                                                                        index
                                                                    ) in order.purchase_orders"
                                                                >
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'purchaseOrderShow',
                                                                            params: {
                                                                                id: po.id,
                                                                            },
                                                                        }"
                                                                        target="_blank"
                                                                    >
                                                                        #{{
                                                                            po.po_number
                                                                        }}
                                                                    </router-link>
                                                                </template>
                                                            </td>
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                ${{
                                                                    product.calculated_profit.toFixed(
                                                                        2
                                                                    )
                                                                }}
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    v-if="
                                                                        (getUser !=
                                                                            null &&
                                                                            getUser.user_type ==
                                                                                1) ||
                                                                        hasRole(
                                                                            'Admin'
                                                                        ) ||
                                                                        hasPerm(
                                                                            'delete-sales-order'
                                                                        )
                                                                    "
                                                                    v-on:click="
                                                                        removeItem(
                                                                            product.id
                                                                        )
                                                                    "
                                                                    class="trashBtn"
                                                                    ><i
                                                                        class="ri-delete-bin-6-line"
                                                                    ></i
                                                                ></a>
                                                            </td>
                                                        </tr>
                                                    </draggable>
                                                        
                                                    </table>
                                                </div>
                                                <div class="table-responsive">
                                                    <table
                                                    class="table table-borderless total-order-sec mb-0"
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <!--<textarea class="form-control" v-model="order.customer_notes" placeholder="" rows="2" style="height:66px;overflow-y:hidden;"></textarea>-->
                                                                <h5
                                                                    style="
                                                                        font-size: 14px;
                                                                        font-weight: 500;
                                                                        margin: 8px 0px;
                                                                    "
                                                                >
                                                                    Internal
                                                                    Notes
                                                                </h5>
                                                                <!--<textarea v-if="isEditMode" class="form-control"
                                                                      v-model="order.notes" placeholder="" rows="2"
                                                                      style="height:66px;overflow-y:hidden;"></textarea>-->
                                                                <vue-editor
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                    v-model="
                                                                        order.notes
                                                                    "
                                                                    :editorToolbar="
                                                                        getMinQuillToolbar()
                                                                    "
                                                                ></vue-editor>

                                                                <p
                                                                    v-if="
                                                                        !isEditMode
                                                                    "
                                                                    v-html="
                                                                        order.notes
                                                                    "
                                                                ></p>

                                                                <br />
                                                                <h5
                                                                    style="
                                                                        font-size: 14px;
                                                                        font-weight: 500;
                                                                        margin: 8px 0px;
                                                                    "
                                                                >
                                                                    Customer
                                                                    Notes
                                                                </h5>
                                                                <!--<textarea v-if="isEditMode" class="form-control"
                                                                      v-model="order.customer_notes" placeholder=""
                                                                      rows="2"
                                                                      style="height:66px;overflow-y:hidden;"></textarea>-->

                                                                <vue-editor
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                    v-model="
                                                                        order.customer_notes
                                                                    "
                                                                    :editorToolbar="
                                                                        getMinQuillToolbar()
                                                                    "
                                                                ></vue-editor>

                                                                <p
                                                                    v-if="
                                                                        !isEditMode
                                                                    "
                                                                    v-html="
                                                                        order.customer_notes
                                                                    "
                                                                ></p>

                                                                <div>
                                                                        <h5 style="font-size: 14px; font-weight: 500; margin: 8px 0px;">PDF Notes</h5>
                                                                        <vue-editor  v-if="
                                                                                isEditMode
                                                                            "
                                                                            v-model="order.pdf_note" :editorToolbar="getQuillToolbar()"></vue-editor>
                                                                        
                                                                        <p class="fshe text-muted"
                                                                            v-if="
                                                                                !isEditMode
                                                                            "
                                                                            v-html="
                                                                                order.pdf_note
                                                                            "
                                                                        ></p>
                                                                        
                                                                    </div>

                                                                <!--<h5 style="font-size: 14px; font-weight: 500; margin:8px 0 8px;">
                                                                Payment Terms</h5>
                                                            <vue-editor v-if="isEditMode" v-model="order.customer_terms" :editorToolbar="getMinQuillToolbar()"></vue-editor>

                                                            <p v-if="!isEditMode" v-html="order.customer_terms"></p>-->
                                                            </td>

                                                            <td
                                                                style="
                                                                    width: 460px;
                                                                "
                                                            >
                                                                <table
                                                                    class="table table-bordered2"
                                                                >
                                                                    <tbody>
                                                                        <tr
                                                                            class="border-none"
                                                                        >
                                                                            <td>
                                                                                <strong
                                                                                    >Sub
                                                                                    Total</strong
                                                                                >
                                                                            </td>
                                                                            <td
                                                                                class="text-right"
                                                                            >
                                                                                <strong
                                                                                    >${{
                                                                                        numberWithCommas(
                                                                                            sub_total_cost.toFixed(
                                                                                                2
                                                                                            )
                                                                                        )
                                                                                    }}</strong
                                                                                >
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    v-if="
                                                                                        order
                                                                                            .discounts
                                                                                            .length ==
                                                                                        0
                                                                                    "
                                                                                    data-toggle="modal"
                                                                                    data-target="#discountModal"
                                                                                    >Add
                                                                                    discount</a
                                                                                >
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    v-else
                                                                                    data-toggle="modal"
                                                                                    data-target="#discountModal"
                                                                                    >Edit
                                                                                    discount</a
                                                                                >
                                                                                <p
                                                                                    v-if="
                                                                                        order
                                                                                            .discounts
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        order
                                                                                            .discounts[0]
                                                                                            .reason
                                                                                    }}
                                                                                </p>
                                                                            </td>
                                                                            <td
                                                                                class="text-right"
                                                                            >
                                                                                <template
                                                                                    v-if="
                                                                                        order
                                                                                            .discounts
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    -${{
                                                                                        getDiscountAmount()
                                                                                    }}
                                                                                </template>
                                                                                <template
                                                                                    v-else
                                                                                    >-</template
                                                                                >
                                                                            </td>
                                                                        </tr>
                                                                        <!--<tr>
                                                                    <td><a href="javascript:void(0);" data-toggle="modal"
                                                                        data-target="#shippingModal">Add Shipping</a>
                                                                    </td>
                                                                    <td class="text-right"> _</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><a href="javascript:void(0);" data-toggle="modal"
                                                                        data-target="#taxModal">Tax</a>
                                                                        <p> &nbsp; </p>
                                                                    </td>
                                                                    <td class="text-right"> _</td>
                                                                </tr>-->

                                                                        <tr>
                                                                            <td>
                                                                                <template
                                                                                    v-if="
                                                                                        order
                                                                                            .charges
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    <p
                                                                                        v-for="(
                                                                                            charge,
                                                                                            index
                                                                                        ) in order.charges"
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0);"
                                                                                            v-on:click="
                                                                                                editCharge(
                                                                                                    charge
                                                                                                )
                                                                                            "
                                                                                            >{{
                                                                                                charge.cost_type
                                                                                            }}:</a
                                                                                        >
                                                                                        

                                                                                        <template
                                                                                            v-if="
                                                                                                charge.quantity !=
                                                                                                    null &&
                                                                                                charge.quantity >
                                                                                                    0
                                                                                            "
                                                                                        >
                                                                                            ${{
                                                                                                charge.amount
                                                                                            }}
                                                                                            x{{
                                                                                                charge.quantity
                                                                                            }}
                                                                                        </template>
                                                                                        <template v-else>
                                                                                         {{
                                                                                                charge.quantity
                                                                                            }}
                                                                                            x
                                                                                            {{
                                                                                                charge.amount
                                                                                            }}
                                                                                            
                                                                                        </template>
                                                                                        <a @click="removeCharge(charge.id)" style="font-size: 14px;" href="javascript:void(0)" class="trashBtn"><i  class="ri-delete-bin-6-line"></i></a>

                                                                                    </p>
                                                                                </template>
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    data-toggle="modal"
                                                                                    data-target="#extraChargeModal"
                                                                                    >Additional
                                                                                    charge</a
                                                                                >
                                                                            </td>
                                                                            <td
                                                                                class="text-right"
                                                                            >
                                                                                <template
                                                                                    v-if="
                                                                                        order
                                                                                            .charges
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    <p
                                                                                        v-for="(
                                                                                            charge,
                                                                                            index
                                                                                        ) in order.charges"
                                                                                    >
                                                                                    <template v-if="isNumber(charge.quantity)">
                                                                                     ${{
                                                                                            charge.quantity !=
                                                                                                null &&
                                                                                            charge.quantity >
                                                                                                0
                                                                                                ? charge.amount *
                                                                                                  charge.quantity
                                                                                                : charge.amount
                                                                                        }}
                                                                                    </template>
                                                                                    <template v-else>
                                                                                    $0.00
                                                                                    </template>
                                                                                       
                                                                                    </p>
                                                                                </template>
                                                                                <template
                                                                                    v-else
                                                                                >
                                                                                    _</template
                                                                                >
                                                                            </td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                <strong
                                                                                    >Total</strong
                                                                                >
                                                                            </td>
                                                                            <td
                                                                                class="text-right"
                                                                            >
                                                                                <strong
                                                                                    >${{
                                                                                        numberWithCommas(
                                                                                            getTotal().toFixed(
                                                                                                2
                                                                                            )
                                                                                        )
                                                                                    }}</strong
                                                                                >
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                </div>
                                            </div>

                                            <div class="tab-pane" id="arrow-attach" role="tabpanel">
                                                
                                                
                                                <template
                                                    v-if="
                                                        order.products.length >
                                                        1
                                                    "
                                                >
                                                    <h3
                                                        style="
                                                            text-transform: uppercase;
                                                        "
                                                    >
                                                        All Artworks
                                                    </h3>
                                                    <div class="invoiceDetails">
                                                        <table
                                                            class="table table-bordered table-hover"
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th
                                                                        style="
                                                                            width: 280px;
                                                                        "
                                                                    >
                                                                        Original
                                                                        customer
                                                                        file
                                                                    </th>
                                                                    <th
                                                                        style="
                                                                            width: 350px;
                                                                        "
                                                                    >
                                                                        Artwork
                                                                        Proof
                                                                    </th>
                                                                    <th>
                                                                        Artwork
                                                                        Status
                                                                    </th>
                                                                    <th>
                                                                        Comments
                                                                    </th>
                                                                    <th
                                                                        style="
                                                                            width: 20px;
                                                                        "
                                                                    ></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template
                                                                    v-if="
                                                                        order
                                                                            .artworks
                                                                            .length >
                                                                        0
                                                                    "
                                                                >
                                                                    <template
                                                                        v-for="(
                                                                            artwork,
                                                                            artworkIndex
                                                                        ) in order.artworks"
                                                                    >
                                                                        <tr
                                                                            v-if="
                                                                                (order.latest_artwork &&
                                                                                    artwork.id ==
                                                                                        order
                                                                                            .latest_artwork
                                                                                            .id) ||
                                                                                artwork.id ==
                                                                                    null
                                                                            "
                                                                        >
                                                                            <td>
                                                                            
                                                                                <div
                                                                                    class="filetitlesec"
                                                                                >
                                                                                    <div
                                                                                        class="filetitleleft"
                                                                                        v-if="
                                                                                            order.original_customer_file
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="ellipsis"
                                                                                        >
                                                                                        <template v-if="artwork.customer_media">
                                                                                            <template v-if="(artwork.customer_media.file_ext == 'jpg' || artwork.customer_media.file_ext == 'png' || artwork.customer_media.file_ext == 'gif')">
                                                                                                <a  href="javascript:void(0)" class="lightbox" 
                                                                                                    @click="imagePreview(artwork.original_customer_file)">
                                                                                                        <img data-v-26877d14="" :src="artwork.customer_media.image_url" 
                                                                                                        style="width: 40px; height: 32px;">
                                                                                                    </a>
                                                                                            </template>
                                                                                        <template v-else>
                                                                                        <span class="file-option-icon"><i :class="getFileIconForAttachment(artwork)"></i></span>
                                                                                        </template>
                                                                                        </template>
                                                                                            <span
                                                                                                :title="
                                                                                                    order.original_customer_file
                                                                                                "
                                                                                                >{{
                                                                                                    order.original_customer_file
                                                                                                        | truncate(
                                                                                                            isEditMode
                                                                                                                ? 22
                                                                                                                : 30
                                                                                                        )
                                                                                                }}</span
                                                                                            >
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="filetitleright"
                                                                                    >
                                                                                        <div
                                                                                            class="file-attachment-wrapper"
                                                                                            v-if="
                                                                                                (getUser !=
                                                                                                    null &&
                                                                                                    getUser.user_type ==
                                                                                                        1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                )
                                                                                            "
                                                                                        >
                                                                                            <!--<template v-if="order.media">{{order.media.filename}}</template>-->
                                                                                            <vue-dropzone
                                                                                                :options="
                                                                                                    dropzoneOptionsOriginalFile
                                                                                                "
                                                                                                :id="
                                                                                                    'item-original-file-' +
                                                                                                    artworkIndex
                                                                                                "
                                                                                                :useCustomSlot="
                                                                                                    true
                                                                                                "
                                                                                                ref="allProductsOriginalFileVueDropzone"
                                                                                                v-on:vdropzone-success="
                                                                                                    (
                                                                                                        file,
                                                                                                        response
                                                                                                    ) =>
                                                                                                        afterAllProductsOriginalFileUploadComplete(
                                                                                                            file,
                                                                                                            response
                                                                                                        )
                                                                                                "
                                                                                                v-on:vdropzone-error="
                                                                                                    (
                                                                                                        file,
                                                                                                        message,
                                                                                                        xhr
                                                                                                    ) =>
                                                                                                        allProductsOriginalFileUploadError(
                                                                                                            file,
                                                                                                            message,
                                                                                                            xhr
                                                                                                        )
                                                                                                "
                                                                                            >
                                                                                                <div
                                                                                                    class="dropzone-custom-content"
                                                                                                >
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-if="
                                                                                                            order.original_customer_file !=
                                                                                                            null
                                                                                                        "
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Replace
                                                                                                    </h3>
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-else
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Drag
                                                                                                        and
                                                                                                        drop
                                                                                                        to
                                                                                                        upload
                                                                                                        content!
                                                                                                    </h3>
                                                                                                </div>
                                                                                            </vue-dropzone>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <span
                                                                                    class="orderbtnsec"
                                                                                    v-if="
                                                                                        order.original_customer_file
                                                                                    "
                                                                                >
                                                                                    <a
                                                                                        href="javascript:void(0)"
                                                                                        v-on:click="
                                                                                            downloadOriginalArtwork(
                                                                                                order.original_customer_file
                                                                                            )
                                                                                        "
                                                                                        class="downlodbtn"
                                                                                        >Download</a
                                                                                    >
                                                                                    <a
                                                                                        href="javascript:void(0)"
                                                                                        v-if="
                                                                                            !isEditMode &&
                                                                                            ((getUser !=
                                                                                                null &&
                                                                                                getUser.user_type ==
                                                                                                    1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                ))
                                                                                        "
                                                                                        v-on:click="
                                                                                            openSendAllArtworkToVendor()
                                                                                        "
                                                                                        >Send
                                                                                        to
                                                                                        vendor</a
                                                                                    >
                                                                                </span>
                                                                            </td>
                                                                            <td>
                                                                                <div
                                                                                    class="filetitlesec"
                                                                                >
                                                                                    <div
                                                                                        class="filetitleleft"
                                                                                        v-if="
                                                                                            artwork.id &&
                                                                                            artwork.attach_link
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="ellipsis"
                                                                                        >
                                                                                            <span
                                                                                                :title="
                                                                                                    artwork.attach_link
                                                                                                "
                                                                                                >{{
                                                                                                    artwork.attach_link
                                                                                                        | truncate(
                                                                                                            isEditMode
                                                                                                                ? 30
                                                                                                                : 40
                                                                                                        )
                                                                                                }}</span
                                                                                            >
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="filetitleright"
                                                                                    >
                                                                                        <div
                                                                                            class="file-attachment-wrapper"
                                                                                            v-if="
                                                                                                (getUser !=
                                                                                                    null &&
                                                                                                    getUser.user_type ==
                                                                                                        1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                )
                                                                                            "
                                                                                        >
                                                                                            <!--<template v-if="artwork.media">{{artwork.media.filename}}</template>-->
                                                                                            <vue-dropzone
                                                                                                :options="
                                                                                                    dropzoneOptionsArtwork
                                                                                                "
                                                                                                :id="
                                                                                                    'other-dropzone-' +
                                                                                                    artworkIndex
                                                                                                "
                                                                                                :useCustomSlot="
                                                                                                    true
                                                                                                "
                                                                                                :key="
                                                                                                    artworkIndex
                                                                                                "
                                                                                                ref="allProductsArtworkFileVueDropzone"
                                                                                                v-on:vdropzone-success="
                                                                                                    (
                                                                                                        file,
                                                                                                        response
                                                                                                    ) =>
                                                                                                        afterAllArtworkUploadComplete(
                                                                                                            file,
                                                                                                            response,
                                                                                                            artworkIndex
                                                                                                        )
                                                                                                "
                                                                                                v-on:vdropzone-error="
                                                                                                    (
                                                                                                        file,
                                                                                                        message,
                                                                                                        xhr
                                                                                                    ) =>
                                                                                                        allArtworkUploadError(
                                                                                                            file,
                                                                                                            message,
                                                                                                            xhr,
                                                                                                            artworkIndex
                                                                                                        )
                                                                                                "
                                                                                            >
                                                                                                <div
                                                                                                    class="dropzone-custom-content"
                                                                                                    v-if="
                                                                                                        artwork.id &&
                                                                                                        artwork.attach_link
                                                                                                    "
                                                                                                >
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-if="
                                                                                                            artwork.attach_link !=
                                                                                                            null
                                                                                                        "
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Replace
                                                                                                    </h3>
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-else
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Drag
                                                                                                        and
                                                                                                        drop
                                                                                                        to
                                                                                                        upload
                                                                                                        content!
                                                                                                    </h3>
                                                                                                </div>
                                                                                            </vue-dropzone>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div
                                                                                    class="filetitlesec"
                                                                                >
                                                                                    <div
                                                                                        class="filetitleleft"
                                                                                    >
                                                                                    <template v-if="artwork.uploaded_media">
                                                                                            <template v-if="(artwork.uploaded_media.file_ext == 'jpg' || artwork.uploaded_media.file_ext == 'png' || artwork.uploaded_media.file_ext == 'gif')">
                                                                                                <a  href="javascript:void(0)" class="lightbox" 
                                                                                                    @click="imagePreview(artwork.attach_link)">
                                                                                                        <img data-v-26877d14="" :src="artwork.uploaded_media.image_url" 
                                                                                                        style="width: 40px; height: 32px;">
                                                                                                    </a>
                                                                                            </template>
                                                                                        <template v-else>
                                                                                        <span class="file-option-icon"><i :class="getFileIconForAttachment(artwork)"></i></span>
                                                                                        </template>
                                                                                        </template>
                                                                                        
                                                                                        <span
                                                                                            class="orderbtnsec"
                                                                                            v-if="
                                                                                                artwork.id &&
                                                                                                artwork.attach_link
                                                                                            "
                                                                                        >
                                                                                            <a
                                                                                                href="javascript:void(0)"
                                                                                                v-if="
                                                                                                    [
                                                                                                        'png',
                                                                                                        'jpg',
                                                                                                        'jpeg',
                                                                                                    ].some(
                                                                                                        (
                                                                                                            image
                                                                                                        ) =>
                                                                                                            artwork.attach_link
                                                                                                                .toLowerCase()
                                                                                                                .includes(
                                                                                                                    image
                                                                                                                )
                                                                                                    )
                                                                                                "
                                                                                                @click="
                                                                                                    imagePreview(
                                                                                                        artwork.attach_link
                                                                                                    )
                                                                                                "
                                                                                                class="downlodbtn"
                                                                                                >Preview</a
                                                                                            >
                                                                                            <a
                                                                                                href="javascript:void(0)"
                                                                                                v-on:click="
                                                                                                    download(
                                                                                                        artwork
                                                                                                    )
                                                                                                "
                                                                                                class="downlodbtn"
                                                                                                >Download</a
                                                                                            >
                                                                                        </span>
                                                                                    </div>
                                                                                    <div
                                                                                        class="filetitleright"
                                                                                    >
                                                                                        <span
                                                                                            class="orderbtnsec"
                                                                                            v-if="
                                                                                                artwork.id &&
                                                                                                artwork.attach_link
                                                                                            "
                                                                                        >
                                                                                            <template
                                                                                                v-if="
                                                                                                    order.latest_artwork &&
                                                                                                    order
                                                                                                        .latest_artwork
                                                                                                        .attach_link !=
                                                                                                        null &&
                                                                                                    order
                                                                                                        .latest_artwork
                                                                                                        .attach_link !=
                                                                                                        '' &&
                                                                                                    !isEditMode
                                                                                                "
                                                                                            >
                                                                                                <a
                                                                                                    href="javascript:void(0)"
                                                                                                    v-if="
                                                                                                        (getUser !=
                                                                                                            null &&
                                                                                                            getUser.user_type ==
                                                                                                                1) ||
                                                                                                        hasRole(
                                                                                                            'Admin'
                                                                                                        )
                                                                                                    "
                                                                                                    @click="
                                                                                                        openSendAllArtworkToCustomer(
                                                                                                            true
                                                                                                        )
                                                                                                    "
                                                                                                    class="pull-right cussendbtn"
                                                                                                    >Send
                                                                                                    to
                                                                                                    customer1</a
                                                                                                >
                                                                                            </template>
                                                                                        </span>
                                                                                    </div>
                                                                                </div>

                                                                                <div
                                                                                    class="orderbtnsec-title"
                                                                                    v-if="
                                                                                        artwork.id
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="title-left"
                                                                                    >
                                                                                        <span
                                                                                            >V-{{
                                                                                                artwork.version_number
                                                                                            }}</span
                                                                                        >
                                                                                        <span
                                                                                            >Uploaded
                                                                                            {{
                                                                                                artwork.updated_at
                                                                                            }}</span
                                                                                        >
                                                                                    </div>
                                                                                    <div
                                                                                        class="title-btnsec"
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0)"
                                                                                            v-if="
                                                                                                (getUser !=
                                                                                                    null &&
                                                                                                    getUser.user_type ==
                                                                                                        1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                )
                                                                                            "
                                                                                            v-on:click="
                                                                                                addNewAllProductArtwork()
                                                                                            "
                                                                                            class="add-versionbtn"
                                                                                            >Add
                                                                                            version</a
                                                                                        >
                                                                                    </div>
                                                                                </div>

                                                                                <div
                                                                                    v-if="
                                                                                        artwork.id
                                                                                    "
                                                                                >
                                                                                    <a
                                                                                        v-if="
                                                                                            order.artworks.filter(
                                                                                                (
                                                                                                    x
                                                                                                ) =>
                                                                                                    x.id !=
                                                                                                    null
                                                                                            )
                                                                                                .length >
                                                                                            1
                                                                                        "
                                                                                        @click="
                                                                                            openAllProductsArtworkVersionsModal()
                                                                                        "
                                                                                        href="javascript:void(0)"
                                                                                        class="previous-vsbtn"
                                                                                        >Previous
                                                                                        version</a
                                                                                    >
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <template
                                                                                    v-if="
                                                                                        isEditMode
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="input-group"
                                                                                    >
                                                                                        <ValidationProvider
                                                                                            name="ArtworkStatus"
                                                                                            rules="required"
                                                                                            v-slot="{
                                                                                                errors,
                                                                                            }"
                                                                                        >
                                                                                            <select
                                                                                                class="form-control"
                                                                                                v-model="
                                                                                                    order
                                                                                                        .artworks[
                                                                                                        artworkIndex
                                                                                                    ]
                                                                                                        .artwork_status_id
                                                                                                "
                                                                                                @change="
                                                                                                    artworkStatusChangeForAll
                                                                                                "
                                                                                            >
                                                                                                <option
                                                                                                    :value="
                                                                                                        null
                                                                                                    "
                                                                                                >
                                                                                                    Select
                                                                                                </option>
                                                                                                <option
                                                                                                    v-for="(
                                                                                                        status,
                                                                                                        index
                                                                                                    ) in artwork_statuses"
                                                                                                    :value="
                                                                                                        status.id
                                                                                                    "
                                                                                                >
                                                                                                    {{
                                                                                                        status.name
                                                                                                    }}
                                                                                                </option>
                                                                                            </select>
                                                                                            <div
                                                                                                class="error"
                                                                                                v-if="
                                                                                                    errors.length
                                                                                                "
                                                                                            >
                                                                                                {{
                                                                                                    errors[0]
                                                                                                }}
                                                                                            </div>
                                                                                        </ValidationProvider>
                                                                                    </div>
                                                                                </template>
                                                                                <template
                                                                                    v-if="
                                                                                        !isEditMode
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        artwork.artwork_status
                                                                                            ? artwork
                                                                                                  .artwork_status
                                                                                                  .name
                                                                                            : null
                                                                                    }}
                                                                                    <span
                                                                                        class="orderbtnsec"
                                                                                        v-if="
                                                                                            artwork.id &&
                                                                                            artwork.attach_link
                                                                                        "
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0)"
                                                                                            v-if="
                                                                                                artwork
                                                                                                    .comments
                                                                                                    .length &&
                                                                                                artwork.artwork_status_id ==
                                                                                                    7
                                                                                            "
                                                                                            @click="
                                                                                                viewComments(
                                                                                                    artwork
                                                                                                )
                                                                                            "
                                                                                            >View
                                                                                            Comments</a
                                                                                        >
                                                                                    </span>
                                                                                </template>
                                                                            </td>
                                                                            <td>
                                                                                <textarea
                                                                                    v-if="
                                                                                        isEditMode
                                                                                    "
                                                                                    class="form-control resize-ta"
                                                                                    v-model="
                                                                                        order
                                                                                            .artworks[
                                                                                            artworkIndex
                                                                                        ]
                                                                                            .comment
                                                                                    "
                                                                                    style="
                                                                                        height: 66px;
                                                                                        overflow-y: hidden;
                                                                                    "
                                                                                ></textarea>
                                                                                <p
                                                                                    v-if="
                                                                                        !isEditMode
                                                                                    "
                                                                                    v-html="
                                                                                        artwork.comment
                                                                                    "
                                                                                ></p>
                                                                            </td>
                                                                            <td>
                                                                                <a
                                                                                    href="javascript:void(0)"
                                                                                    v-if="
                                                                                        (getUser !=
                                                                                            null &&
                                                                                            getUser.user_type ==
                                                                                                1) ||
                                                                                        hasRole(
                                                                                            'Admin'
                                                                                        ) ||
                                                                                        hasPerm(
                                                                                            'delete-sales-order'
                                                                                        )
                                                                                    "
                                                                                    v-on:click="
                                                                                        removeAllProductArtwork(
                                                                                            artworkIndex,
                                                                                            artwork.id
                                                                                        )
                                                                                    "
                                                                                    class="trashBtn"
                                                                                    ><i
                                                                                        class="ri-delete-bin-6-line"
                                                                                    ></i
                                                                                ></a>
                                                                                <!--<a href="javascript:void(0)"
                                                                               v-on:click="addNewAllProductArtwork()"
                                                                               v-if="isEditMode"
                                                                               class="addNew1"><i
                                                                                class="fa fa-plus-circle"
                                                                                aria-hidden="true"></i></a>-->
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                    <tr>
                                                                        <td>
                                                                            <template
                                                                                v-if="
                                                                                    order.original_customer_file
                                                                                "
                                                                            >
                                                                            <template v-if="artwork.customer_media">
                                                                                            <template v-if="(artwork.customer_media.file_ext == 'jpg' || artwork.customer_media.file_ext == 'png' || artwork.customer_media.file_ext == 'gif')">
                                                                                                <a  href="javascript:void(0)" class="lightbox" 
                                                                                                    @click="imagePreview(artwork.original_customer_file)">
                                                                                                        <img data-v-26877d14="" :src="artwork.customer_media.image_url" 
                                                                                                        style="width: 40px; height: 32px;">
                                                                                                    </a>
                                                                                            </template>
                                                                                        <template v-else>
                                                                                        <span class="file-option-icon"><i :class="getFileIconForAttachment(artwork)"></i></span>
                                                                                        </template>
                                                                                        </template>

                                                                                <span
                                                                                    :title="
                                                                                        order.original_customer_file
                                                                                    "
                                                                                    >{{
                                                                                        order.original_customer_file
                                                                                            | truncate(
                                                                                                isEditMode
                                                                                                    ? 22
                                                                                                    : 30
                                                                                            )
                                                                                    }}</span
                                                                                >
                                                                                <span
                                                                                    class="orderbtnsec"
                                                                                    ><a
                                                                                        href="javascript:void(0)"
                                                                                        v-on:click="
                                                                                            downloadOriginalArtwork(
                                                                                                order.original_customer_file
                                                                                            )
                                                                                        "
                                                                                        class="downlodbtn"
                                                                                        >Download</a
                                                                                    >
                                                                                    <a
                                                                                        href="javascript:void(0)"
                                                                                        v-if="
                                                                                            !isEditMode &&
                                                                                            ((getUser !=
                                                                                                null &&
                                                                                                getUser.user_type ==
                                                                                                    1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                ))
                                                                                        "
                                                                                        v-on:click="
                                                                                            openSendAllArtworkToVendor()
                                                                                        "
                                                                                        >Send
                                                                                        to
                                                                                        vendor</a
                                                                                    ></span
                                                                                ><br />
                                                                            </template>

                                                                            <div
                                                                                class="filetitlesec"
                                                                            >
                                                                                <div
                                                                                    class="file-attachment-wrapper"
                                                                                    v-if="
                                                                                        (getUser !=
                                                                                            null &&
                                                                                            getUser.user_type ==
                                                                                                1) ||
                                                                                        hasRole(
                                                                                            'Admin'
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <!--<template v-if="order.media">{{order.media.filename}}</template>-->
                                                                                    <vue-dropzone
                                                                                        :options="
                                                                                            dropzoneOptionsOriginalFile
                                                                                        "
                                                                                        :id="'item-original-file-1asd'"
                                                                                        :useCustomSlot="
                                                                                            true
                                                                                        "
                                                                                        ref="allProductsOriginalFileVueDropzone"
                                                                                        v-on:vdropzone-success="
                                                                                            (
                                                                                                file,
                                                                                                response
                                                                                            ) =>
                                                                                                afterAllProductsOriginalFileUploadComplete(
                                                                                                    file,
                                                                                                    response
                                                                                                )
                                                                                        "
                                                                                        v-on:vdropzone-error="
                                                                                            (
                                                                                                file,
                                                                                                message,
                                                                                                xhr
                                                                                            ) =>
                                                                                                allProductsOriginalFileUploadError(
                                                                                                    file,
                                                                                                    message,
                                                                                                    xhr
                                                                                                )
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="dropzone-custom-content"
                                                                                        >
                                                                                            <h3
                                                                                                class="dropzone-custom-title"
                                                                                                v-if="
                                                                                                    order.original_customer_file !=
                                                                                                    null
                                                                                                "
                                                                                            >
                                                                                                <i
                                                                                                    class="fa fa-upload"
                                                                                                    aria-hidden="true"
                                                                                                ></i>
                                                                                                Replace
                                                                                            </h3>
                                                                                            <h3
                                                                                                class="dropzone-custom-title"
                                                                                                v-else
                                                                                            >
                                                                                                <i
                                                                                                    class="fa fa-upload"
                                                                                                    aria-hidden="true"
                                                                                                ></i>
                                                                                                Drag
                                                                                                and
                                                                                                drop
                                                                                                to
                                                                                                upload
                                                                                                content!
                                                                                            </h3>
                                                                                        </div>
                                                                                    </vue-dropzone>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            colspan="4"
                                                                        >
                                                                            <a
                                                                                href="javascript:void(0)"
                                                                                v-on:click="
                                                                                    addNewAllProductArtwork()
                                                                                "
                                                                                v-if="
                                                                                    isEditMode
                                                                                "
                                                                                class="addNew1"
                                                                                ><i
                                                                                    class="fa fa-plus-circle"
                                                                                    aria-hidden="true"
                                                                                ></i
                                                                            ></a>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                                <h3
                                                    style="
                                                        text-transform: uppercase;
                                                    "
                                                >
                                                    ARTWORKS
                                                    <template
                                                        v-if="
                                                            eachProductsHasArtwork &&
                                                            order.products
                                                                .length > 1 &&
                                                            !isEditMode
                                                        "
                                                    >
                                                        <a
                                                            href="javascript:void(0)"
                                                            @click="
                                                                openSendAllArtworkToCustomer(
                                                                    false
                                                                )
                                                            "
                                                            class="pull-right cussendbtn"
                                                            >Send all artworks
                                                            to customer</a
                                                        >
                                                    </template>

                                                    <a
                                                        v-if="
                                                            order.products
                                                                .length > 1
                                                        "
                                                        href="javascript:void(0)"
                                                        @click="
                                                            toggleItemsInArtworkSection =
                                                                !toggleItemsInArtworkSection
                                                        "
                                                        class="pull-right cussendbtn"
                                                    >
                                                        <template
                                                            v-if="
                                                                toggleItemsInArtworkSection
                                                            "
                                                            >Hide</template
                                                        >
                                                        <template
                                                            v-if="
                                                                !toggleItemsInArtworkSection
                                                            "
                                                            >Show</template
                                                        >
                                                    </a>
                                                </h3>
                                                <div
                                                    class="invoiceDetails"
                                                    v-if="
                                                        toggleItemsInArtworkSection ||
                                                        order.products
                                                            .length === 1
                                                    "
                                                >
                                                    <table
                                                        class="table table-bordered table-hover"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    style="
                                                                        width: 120px;
                                                                    "
                                                                >
                                                                    Product Name
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 200px;
                                                                    "
                                                                >
                                                                    Description
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 260px;
                                                                    "
                                                                >
                                                                    Original
                                                                    Customer
                                                                    File
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 230px;
                                                                    "
                                                                >
                                                                    Approved
                                                                    Artwork
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 120px;
                                                                    "
                                                                >
                                                                    Artwork
                                                                    Status
                                                                </th>
                                                                <!--<th style="width: 180px;">Comments</th>-->
                                                                <th
                                                                    style="
                                                                        width: 20px;
                                                                    "
                                                                >
                                                                    <!--Actions-->
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody
                                                            v-if="
                                                                order.products
                                                                    .length > 0
                                                            "
                                                        >
                                                            <template
                                                                v-for="(
                                                                    product,
                                                                    index
                                                                ) in order.products.filter(
                                                                    (x) =>
                                                                        x.id !=
                                                                        null
                                                                )"
                                                            >
                                                                <template
                                                                    v-if="
                                                                        product.artworks &&
                                                                        product.artworks.filter(
                                                                            (
                                                                                art
                                                                            ) =>
                                                                                art.id ==
                                                                                    null ||
                                                                                (product.latest_artwork &&
                                                                                    art.id ==
                                                                                        product
                                                                                            .latest_artwork
                                                                                            .id)
                                                                        )
                                                                            .length >
                                                                            0
                                                                    "
                                                                >
                                                                    <template
                                                                        v-for="(
                                                                            artwork,
                                                                            artworkIndex
                                                                        ) in product.artworks"
                                                                    >
                                                                        <tr
                                                                            v-if="
                                                                                (product.latest_artwork &&
                                                                                    artwork.id ==
                                                                                        product
                                                                                            .latest_artwork
                                                                                            .id) ||
                                                                                artwork.id ==
                                                                                    null
                                                                            "
                                                                        >
                                                                            <!--<template v-if="artworkIndex == 0">-->
                                                                            <template
                                                                                v-if="
                                                                                    checkIfFirstRow(
                                                                                        product,
                                                                                        index,
                                                                                        artwork,
                                                                                        artworkIndex
                                                                                    )
                                                                                "
                                                                            >
                                                                                <td
                                                                                    :rowspan="
                                                                                        product.artworks.filter(
                                                                                            (
                                                                                                art
                                                                                            ) =>
                                                                                                art.id ==
                                                                                                    null ||
                                                                                                (product.latest_artwork &&
                                                                                                    art.id ==
                                                                                                        product
                                                                                                            .latest_artwork
                                                                                                            .id)
                                                                                        )
                                                                                            .length
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        product.product_name
                                                                                    }}
                                                                                </td>
                                                                                <td
                                                                                    :rowspan="
                                                                                        product.artworks.filter(
                                                                                            (
                                                                                                art
                                                                                            ) =>
                                                                                                art.id ==
                                                                                                    null ||
                                                                                                (product.latest_artwork &&
                                                                                                    art.id ==
                                                                                                        product
                                                                                                            .latest_artwork
                                                                                                            .id)
                                                                                        )
                                                                                            .length
                                                                                    "
                                                                                >
                                                                                    <p
                                                                                        v-html="
                                                                                            product.product_desc
                                                                                        "
                                                                                    ></p>
                                                                                </td>
                                                                                <td
                                                                                    :rowspan="
                                                                                        product.artworks.filter(
                                                                                            (
                                                                                                art
                                                                                            ) =>
                                                                                                art.id ==
                                                                                                    null ||
                                                                                                (product.latest_artwork &&
                                                                                                    art.id ==
                                                                                                        product
                                                                                                            .latest_artwork
                                                                                                            .id)
                                                                                        )
                                                                                            .length
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="filetitlesec"
                                                                                    >
                                                                                        <div
                                                                                            class="filetitleleft"
                                                                                            v-if="
                                                                                                product.id &&
                                                                                                product.original_customer_file
                                                                                            "
                                                                                        >

                                                                                        <template v-if="artwork.customer_media">
                                                                                        <template v-if="(artwork.customer_media.file_ext == 'jpg' || artwork.customer_media.file_ext == 'png' || artwork.customer_media.file_ext == 'gif')">
                                                                                            <a  href="javascript:void(0)" class="lightbox" 
                                                                                                @click="imagePreview(artwork.original_customer_file)">
                                                                                                    <img data-v-26877d14="" :src="artwork.customer_media.image_url" 
                                                                                                    style="width: 40px; height: 32px;">
                                                                                                </a>
                                                                                        </template>
                                                                                        <template v-else>
                                                                                        <span class="file-option-icon"><i :class="getFileIconForAttachment(artwork)"></i></span>
                                                                                        </template>
                                                                                    </template>
                                                                                    <!-- {{product}} -->
                                                                                            <div
                                                                                                class="ellipsis"
                                                                                            >
                                                                                                <span
                                                                                                    :title="
                                                                                                        product.original_customer_file
                                                                                                    "
                                                                                                    >{{
                                                                                                        product.original_customer_file
                                                                                                            | truncate(
                                                                                                                isEditMode
                                                                                                                    ? 23
                                                                                                                    : 30
                                                                                                            )
                                                                                                    }}</span
                                                                                                >
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            class="filetitleright"
                                                                                        >
                                                                                            <div
                                                                                                v-if="
                                                                                                    (getUser !=
                                                                                                        null &&
                                                                                                        getUser.user_type ==
                                                                                                            1) ||
                                                                                                    hasRole(
                                                                                                        'Admin'
                                                                                                    )
                                                                                                "
                                                                                                class="file-attachment-wrapper"
                                                                                            >
                                                                                                <!--<template v-if="product.media">{{product.media.filename}}</template>-->
                                                                                                <vue-dropzone
                                                                                                    :options="
                                                                                                        dropzoneOptionsOriginalFile
                                                                                                    "
                                                                                                    :id="
                                                                                                        'item-original-file-' +
                                                                                                        index
                                                                                                    "
                                                                                                    :use-custom-slot="
                                                                                                        true
                                                                                                    "
                                                                                                    :key="
                                                                                                        index
                                                                                                    "
                                                                                                    ref="itemOriginalFileVueDropzones"
                                                                                                    v-on:vdropzone-success="
                                                                                                        (
                                                                                                            file,
                                                                                                            response
                                                                                                        ) =>
                                                                                                            afterItemOriginalFileUploadComplete(
                                                                                                                file,
                                                                                                                response,
                                                                                                                index
                                                                                                            )
                                                                                                    "
                                                                                                    v-on:vdropzone-error="
                                                                                                        (
                                                                                                            file,
                                                                                                            message,
                                                                                                            xhr
                                                                                                        ) =>
                                                                                                            itemOriginalFileUploadError(
                                                                                                                file,
                                                                                                                message,
                                                                                                                xhr,
                                                                                                                index
                                                                                                            )
                                                                                                    "
                                                                                                >
                                                                                                    <div
                                                                                                        class="dropzone-custom-content"
                                                                                                    >
                                                                                                        <h3
                                                                                                            class="dropzone-custom-title"
                                                                                                            v-if="
                                                                                                                product.original_customer_file !=
                                                                                                                null
                                                                                                            "
                                                                                                        >
                                                                                                            <i
                                                                                                                class="fa fa-upload"
                                                                                                                aria-hidden="true"
                                                                                                            ></i>
                                                                                                            Replace
                                                                                                        </h3>
                                                                                                        <h3
                                                                                                            class="dropzone-custom-title"
                                                                                                            v-else
                                                                                                        >
                                                                                                            <i
                                                                                                                class="fa fa-upload"
                                                                                                                aria-hidden="true"
                                                                                                            ></i>
                                                                                                            Drag
                                                                                                            and
                                                                                                            drop
                                                                                                            to
                                                                                                            upload
                                                                                                            content!
                                                                                                        </h3>
                                                                                                    </div>
                                                                                                </vue-dropzone>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <span
                                                                                        class="orderbtnsec"
                                                                                        v-if="
                                                                                            product.id &&
                                                                                            product.original_customer_file
                                                                                        "
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0)"
                                                                                            @click="
                                                                                                downloadOriginalArtwork(
                                                                                                    product.original_customer_file
                                                                                                )
                                                                                            "
                                                                                            class="downlodbtn"
                                                                                            >Download</a
                                                                                        >
                                                                                        <a
                                                                                            href="javascript:void(0)"
                                                                                            v-if="
                                                                                                !isEditMode &&
                                                                                                ((getUser !=
                                                                                                    null &&
                                                                                                    getUser.user_type ==
                                                                                                        1) ||
                                                                                                    hasRole(
                                                                                                        'Admin'
                                                                                                    ))
                                                                                            "
                                                                                            @click="
                                                                                                openSendArtworkToVendor(
                                                                                                    product
                                                                                                )
                                                                                            "
                                                                                            >Send
                                                                                            to
                                                                                            vendor</a
                                                                                        >
                                                                                    </span>
                                                                                </td>
                                                                            </template>

                                                                            <td>
                                                                                <div
                                                                                    class="filetitlesec"
                                                                                >
                                                                                    <div
                                                                                        class="filetitleleft"
                                                                                        v-if="
                                                                                            artwork.id &&
                                                                                            artwork.attach_link
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="ellipsis"
                                                                                        >
                                                                                            <span
                                                                                                :title="
                                                                                                    artwork.attach_link
                                                                                                "
                                                                                                >{{
                                                                                                    artwork.attach_link
                                                                                                        | truncate(
                                                                                                            isEditMode
                                                                                                                ? 80
                                                                                                                : 90
                                                                                                        )
                                                                                                }}</span
                                                                                            >
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="filetitleright"
                                                                                    >
                                                                                        <div
                                                                                            class="file-attachment-wrapper"
                                                                                            v-if="
                                                                                                (getUser !=
                                                                                                    null &&
                                                                                                    getUser.user_type ==
                                                                                                        1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                )
                                                                                            "
                                                                                        >
                                                                                            <!--<template v-if="artwork.media">{{artwork.media.filename}}</template>-->
                                                                                            <vue-dropzone
                                                                                                :options="
                                                                                                    dropzoneOptionsArtwork
                                                                                                "
                                                                                                :id="
                                                                                                    'item-dropzone-' +
                                                                                                    index +
                                                                                                    '-' +
                                                                                                    artworkIndex
                                                                                                "
                                                                                                :use-custom-slot="
                                                                                                    true
                                                                                                "
                                                                                                :key="
                                                                                                    index
                                                                                                "
                                                                                                ref="itemArtworkFileVueDropzones"
                                                                                                v-on:vdropzone-success="
                                                                                                    (
                                                                                                        file,
                                                                                                        response
                                                                                                    ) =>
                                                                                                        afterItemArtworkUploadComplete(
                                                                                                            file,
                                                                                                            response,
                                                                                                            index,
                                                                                                            artworkIndex
                                                                                                        )
                                                                                                "
                                                                                                v-on:vdropzone-error="
                                                                                                    (
                                                                                                        file,
                                                                                                        message,
                                                                                                        xhr
                                                                                                    ) =>
                                                                                                        itemArtworkUploadError(
                                                                                                            file,
                                                                                                            message,
                                                                                                            xhr,
                                                                                                            artworkIndex
                                                                                                        )
                                                                                                "
                                                                                            >
                                                                                                <div
                                                                                                    class="dropzone-custom-content"
                                                                                                >
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-if="
                                                                                                            artwork.attach_link !=
                                                                                                            null
                                                                                                        "
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Replace
                                                                                                    </h3>
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-else
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Drag
                                                                                                        and
                                                                                                        drop
                                                                                                        to
                                                                                                        upload
                                                                                                        content!
                                                                                                    </h3>
                                                                                                </div>
                                                                                            </vue-dropzone>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    v-if="
                                                                                        artwork.id
                                                                                    "
                                                                                    class="orderbtnsec2"
                                                                                >
                                                                                    <div
                                                                                        class="filetitlesec"
                                                                                    >
                                                                                        <div
                                                                                            class="filetitleleft"
                                                                                        >
                                                                                            <div
                                                                                                class="orderbtnsec"
                                                                                                v-if="
                                                                                                    artwork.id &&
                                                                                                    artwork.attach_link
                                                                                                "
                                                                                            >
                                                                                            <template v-if="artwork.uploaded_media">
                                                                                            <template v-if="(artwork.uploaded_media.file_ext == 'jpg' || artwork.uploaded_media.file_ext == 'png' || artwork.uploaded_media.file_ext == 'gif')">
                                                                                                <a  href="javascript:void(0)" class="lightbox" 
                                                                                                    @click="imagePreview(artwork.attach_link)">
                                                                                                        <img data-v-26877d14="" :src="artwork.uploaded_media.image_url" 
                                                                                                        style="width: 40px; height: 32px;">
                                                                                                    </a>
                                                                                            </template>
                                                                                        <template v-else>
                                                                                        <span class="file-option-icon"><i :class="getFileIconForAttachment(artwork)"></i></span>
                                                                                        </template>
                                                                                        </template>
                                                                                                   
                                                                                                <a
                                                                                                    href="javascript:void(0)"
                                                                                                    v-if="
                                                                                                        [
                                                                                                            'png',
                                                                                                            'jpg',
                                                                                                            'jpeg',
                                                                                                        ].some(
                                                                                                            (
                                                                                                                image
                                                                                                            ) =>
                                                                                                                artwork.attach_link
                                                                                                                    .toLowerCase()
                                                                                                                    .includes(
                                                                                                                        image
                                                                                                                    )
                                                                                                        )
                                                                                                    "
                                                                                                    @click="
                                                                                                        imagePreview(
                                                                                                            artwork.attach_link
                                                                                                        )
                                                                                                    "
                                                                                                    class="downlodbtn"
                                                                                                    >Preview</a
                                                                                                >
                                                                                                <a
                                                                                                    href="javascript:void(0)"
                                                                                                    v-on:click="
                                                                                                        download(
                                                                                                            artwork
                                                                                                        )
                                                                                                    "
                                                                                                    class="downlodbtn"
                                                                                                    >Download</a
                                                                                                >
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            class="filetitleright"
                                                                                        >
                                                                                            <span
                                                                                                class="orderbtnsec"
                                                                                            >
                                                                                                <a
                                                                                                    href="javascript:void(0)"
                                                                                                    @click="
                                                                                                        openSendArtworkToCustomer(
                                                                                                            product,
                                                                                                            artwork
                                                                                                        )
                                                                                                    "
                                                                                                    v-if="
                                                                                                        artwork.id &&
                                                                                                        artwork.attach_link &&
                                                                                                        !isEditMode &&
                                                                                                        ((getUser !=
                                                                                                            null &&
                                                                                                            getUser.user_type ==
                                                                                                                1) ||
                                                                                                            hasRole(
                                                                                                                'Admin'
                                                                                                            ))
                                                                                                    "
                                                                                                    >Send
                                                                                                    to
                                                                                                    customer</a
                                                                                                >
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div
                                                                                        class="orderbtnsec-title"
                                                                                    >
                                                                                        <div
                                                                                            class="title-left"
                                                                                        >
                                                                                            <span
                                                                                                >V-{{
                                                                                                    artwork.version_number
                                                                                                }}</span
                                                                                            >
                                                                                            <span
                                                                                                >Uploaded
                                                                                                {{
                                                                                                    artwork.updated_at
                                                                                                }}</span
                                                                                            >
                                                                                        </div>
                                                                                        <div
                                                                                            class="title-btnsec"
                                                                                        >
                                                                                            <a
                                                                                                href="javascript:void(0)"
                                                                                                v-if="
                                                                                                    (getUser !=
                                                                                                        null &&
                                                                                                        getUser.user_type ==
                                                                                                            1) ||
                                                                                                    hasRole(
                                                                                                        'Admin'
                                                                                                    )
                                                                                                "
                                                                                                v-on:click="
                                                                                                    addNewItemAttachVersion(
                                                                                                        index
                                                                                                    )
                                                                                                "
                                                                                                class="add-versionbtn"
                                                                                                >Add
                                                                                                version</a
                                                                                            >
                                                                                        </div>
                                                                                    </div>
                                                                                    <span
                                                                                        class="orderbtnsec"
                                                                                    >
                                                                                        <a
                                                                                            v-if="
                                                                                                product
                                                                                                    .artworks
                                                                                                    .length >
                                                                                                1
                                                                                            "
                                                                                            @click="
                                                                                                openProductArtworkVersionsModal(
                                                                                                    product
                                                                                                )
                                                                                            "
                                                                                            href="javascript:void(0)"
                                                                                            class="previous-vsbtn"
                                                                                            >Previous
                                                                                            version</a
                                                                                        >
                                                                                        <!--<a
                                                                                    href="javascript:void(0)"
                                                                                    @click="openSendArtworkToCustomer(product, artwork)"
                                                                                    v-if="artwork.id && artwork.attach_link && !isEditMode">Send to customer</a>-->
                                                                                    </span>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <template
                                                                                    v-if="
                                                                                        isEditMode
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="input-group"
                                                                                    >
                                                                                        <ValidationProvider
                                                                                            name="ArtworkStatus"
                                                                                            rules="required"
                                                                                            v-slot="{
                                                                                                errors,
                                                                                            }"
                                                                                        >
                                                                                            <select
                                                                                                class="form-control"
                                                                                                v-model="
                                                                                                    order
                                                                                                        .products[
                                                                                                        index
                                                                                                    ]
                                                                                                        .artworks[
                                                                                                        artworkIndex
                                                                                                    ]
                                                                                                        .artwork_status_id
                                                                                                "
                                                                                            >
                                                                                                <option
                                                                                                    :value="
                                                                                                        null
                                                                                                    "
                                                                                                >
                                                                                                    Select
                                                                                                </option>
                                                                                                <option
                                                                                                    v-for="(
                                                                                                        status,
                                                                                                        index
                                                                                                    ) in artwork_statuses"
                                                                                                    :value="
                                                                                                        status.id
                                                                                                    "
                                                                                                >
                                                                                                    {{
                                                                                                        status.name
                                                                                                    }}
                                                                                                </option>
                                                                                            </select>
                                                                                            <div
                                                                                                class="error"
                                                                                                v-if="
                                                                                                    errors.length
                                                                                                "
                                                                                            >
                                                                                                {{
                                                                                                    errors[0]
                                                                                                }}
                                                                                            </div>
                                                                                        </ValidationProvider>
                                                                                    </div>
                                                                                </template>
                                                                                <template
                                                                                    v-if="
                                                                                        !isEditMode
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        artwork.artwork_status
                                                                                            ? artwork
                                                                                                  .artwork_status
                                                                                                  .name
                                                                                            : null
                                                                                    }}

                                                                                    <div
                                                                                        class="orderbtnsec"
                                                                                        v-if="
                                                                                            artwork.id &&
                                                                                            artwork.attach_link
                                                                                        "
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0)"
                                                                                            v-if="
                                                                                                artwork
                                                                                                    .comments
                                                                                                    .length &&
                                                                                                artwork.artwork_status_id ==
                                                                                                    7
                                                                                            "
                                                                                            @click="
                                                                                                viewComments(
                                                                                                    artwork
                                                                                                )
                                                                                            "
                                                                                            >View
                                                                                            Comments</a
                                                                                        >
                                                                                    </div>
                                                                                </template>
                                                                            </td>
                                                                            <!--<td>
                                                                        <textarea v-if="isEditMode"
                                                                                  class="form-control resize-ta"
                                                                                  v-model="order.products[index].artworks[artworkIndex].comment"
                                                                                  style="height:66px;overflow-y:hidden;"></textarea>
                                                                            <p v-if="!isEditMode"
                                                                               v-html="artwork.comment"></p>
                                                                        </td>-->
                                                                            <td
                                                                                style="
                                                                                    width: 20px;
                                                                                "
                                                                            >
                                                                                <a
                                                                                    href="javascript:void(0)"
                                                                                    v-if="
                                                                                        (getUser !=
                                                                                            null &&
                                                                                            getUser.user_type ==
                                                                                                1) ||
                                                                                        hasRole(
                                                                                            'Admin'
                                                                                        ) ||
                                                                                        hasPerm(
                                                                                            'delete-sales-order'
                                                                                        )
                                                                                    "
                                                                                    v-on:click="
                                                                                        removeItemAttach(
                                                                                            index,
                                                                                            artworkIndex,
                                                                                            product.id,
                                                                                            artwork.id
                                                                                        )
                                                                                    "
                                                                                    class="trashBtn"
                                                                                    ><i
                                                                                        class="ri-delete-bin-6-line"
                                                                                    ></i
                                                                                ></a>
                                                                                <!--<a href="javascript:void(0)"
                                                                               v-if="isEditMode"
                                                                               v-on:click="addNewItemAttach(index)"
                                                                               class="addNew1"><i
                                                                                class="fa fa-plus-circle"
                                                                                aria-hidden="true"></i></a>-->
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </template>
                                                                <template
                                                                    v-if="
                                                                        !product.artworks ||
                                                                        product
                                                                            .artworks
                                                                            .length ==
                                                                            0
                                                                    "
                                                                >
                                                                    <tr>
                                                                        <td
                                                                            rowspan="1"
                                                                        >
                                                                            {{
                                                                                product.product_name
                                                                            }}
                                                                        </td>
                                                                        <td
                                                                            rowspan="1"
                                                                        >
                                                                            <p
                                                                                v-html="
                                                                                    product.product_desc
                                                                                "
                                                                            ></p>
                                                                        </td>

                                                                        <td
                                                                            colspan="7"
                                                                        >
                                                                            <a
                                                                                href="javascript:void(0)"
                                                                                v-if="
                                                                                    (getUser !=
                                                                                        null &&
                                                                                        getUser.user_type ==
                                                                                            1) ||
                                                                                    hasRole(
                                                                                        'Admin'
                                                                                    )
                                                                                "
                                                                                @click="
                                                                                    addNewItemAttach(
                                                                                        index
                                                                                    )
                                                                                "
                                                                                class="addNew1"
                                                                            >
                                                                                <i
                                                                                    class="fa fa-plus-circle"
                                                                                    aria-hidden="true"
                                                                                ></i>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <h3
                                                    style="
                                                        text-transform: uppercase;
                                                    "
                                                >
                                                    OTHER ATTACHMENTS
                                                </h3>
                                                <div class="invoiceDetails">
                                                    <table
                                                        class="table table-bordered table-hover"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th>Type</th>
                                                                <th
                                                                    style="
                                                                        width: 300px;
                                                                    "
                                                                >
                                                                    File
                                                                </th>
                                                                <th>
                                                                    Comments
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 120px;
                                                                    "
                                                                >
                                                                    Upload time
                                                                </th>
                                                                <th>
                                                                    Upload file
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 20px;
                                                                    "
                                                                >
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template
                                                                v-if="
                                                                    order
                                                                        .attachments
                                                                        .length >
                                                                    0
                                                                "
                                                            >
                                                                <tr
                                                                    v-for="(
                                                                        artwork,
                                                                        artworkIndex
                                                                    ) in order.attachments"
                                                                >
                                                                    <td>
                                                                        <input
                                                                            v-if="
                                                                                isEditMode
                                                                            "
                                                                            type="text"
                                                                            class="form-control"
                                                                            placeholder=""
                                                                            v-model="
                                                                                order
                                                                                    .attachments[
                                                                                    artworkIndex
                                                                                ]
                                                                                    .attach_type
                                                                            "
                                                                            id="searchQuotationInput"
                                                                        />
                                                                        <p
                                                                            v-if="
                                                                                !isEditMode
                                                                            "
                                                                            v-html="
                                                                                artwork.attach_type
                                                                            "
                                                                        ></p>
                                                                    </td>
                                                                    <td>
                                                                        <template
                                                                            v-if="
                                                                                artwork.id &&
                                                                                artwork.attach_link
                                                                            "
                                                                        >

                                                                        <template v-if="artwork.uploaded_media">
                                                                        <template v-if="(artwork.uploaded_media.file_ext == 'jpg' || artwork.uploaded_media.file_ext == 'png' || artwork.uploaded_media.file_ext == 'gif')">
                                                                            <a  href="javascript:void(0)" class="lightbox" 
                                                                                @click="imagePreview1(artwork.attach_link)">
                                                                                    <img data-v-26877d14="" :src="artwork.uploaded_media.image_url" 
                                                                                    style="width: 40px; height: 32px;">
                                                                                </a>
                                                                        </template>
                                                                        <template v-else>
                                                                        <span class="file-option-icon"><i :class="getFileIconForAttachment(artwork)"></i></span>
                                                                        </template>
                                                                    </template>
                                                                                
                                                                            <span
                                                                                :title="
                                                                                    artwork.attach_link
                                                                                "
                                                                                >{{
                                                                                    artwork.attach_link
                                                                                        | truncate(
                                                                                            100
                                                                                        )
                                                                                }}</span
                                                                            >

                                                                            <div
                                                                                class="orderbtnsec"
                                                                            >
                                                                                <a
                                                                                    href="javascript:void(0)"
                                                                                    v-on:click="
                                                                                        download(
                                                                                            artwork
                                                                                        )
                                                                                    "
                                                                                    class="downlodbtn"
                                                                                    >Download</a
                                                                                >
                                                                            </div>
                                                                            <br />
                                                                        </template>
                                                                        <template
                                                                            v-if="
                                                                                artwork.id
                                                                            "
                                                                        >
                                                                            Version:
                                                                            {{
                                                                                artwork.version_number
                                                                            }}
                                                                        </template>
                                                                    </td>
                                                                    <td>
                                                                        <textarea
                                                                            v-if="
                                                                                isEditMode
                                                                            "
                                                                            class="form-control resize-ta"
                                                                            v-model="
                                                                                order
                                                                                    .attachments[
                                                                                    artworkIndex
                                                                                ]
                                                                                    .comment
                                                                            "
                                                                            style="
                                                                                height: 66px;
                                                                                overflow-y: hidden;
                                                                            "
                                                                        ></textarea>
                                                                        <p
                                                                            v-if="
                                                                                !isEditMode
                                                                            "
                                                                            v-html="
                                                                                artwork.comment
                                                                            "
                                                                        ></p>
                                                                    </td>
                                                                    <td>
                                                                        <template
                                                                            v-if="
                                                                                artwork.id
                                                                            "
                                                                        >
                                                                            {{
                                                                                artwork.updated_at
                                                                            }}
                                                                        </template>
                                                                    </td>
                                                                    <td
                                                                        width="10%"
                                                                    >
                                                                        <div
                                                                            class="filetitlesec"
                                                                        >
                                                                            <div
                                                                                class="file-attachment-wrapper"
                                                                                v-if="
                                                                                    (getUser !=
                                                                                        null &&
                                                                                        getUser.user_type ==
                                                                                            1) ||
                                                                                    hasRole(
                                                                                        'Admin'
                                                                                    )
                                                                                "
                                                                            >
                                                                                <!--<template v-if="artwork.media">{{artwork.media.filename}}</template>-->
                                                                                <vue-dropzone
                                                                                    :options="
                                                                                        dropzoneOptions
                                                                                    "
                                                                                    :id="
                                                                                        'other-dropzone-' +
                                                                                        artworkIndex
                                                                                    "
                                                                                    :use-custom-slot="
                                                                                        true
                                                                                    "
                                                                                    :key="
                                                                                        artworkIndex
                                                                                    "
                                                                                    ref="otherAttachments"
                                                                                    v-on:vdropzone-success="
                                                                                        (
                                                                                            file,
                                                                                            response
                                                                                        ) =>
                                                                                            afterArtworkUploadComplete(
                                                                                                file,
                                                                                                response,
                                                                                                artworkIndex
                                                                                            )
                                                                                    "
                                                                                    v-on:vdropzone-error="
                                                                                        (
                                                                                            file,
                                                                                            message,
                                                                                            xhr
                                                                                        ) =>
                                                                                            otherAttachmentUploadError(
                                                                                                file,
                                                                                                message,
                                                                                                xhr,
                                                                                                artworkIndex
                                                                                            )
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="dropzone-custom-content"
                                                                                    >
                                                                                        <h3
                                                                                            class="dropzone-custom-title"
                                                                                            v-if="
                                                                                                artwork.attach_link !=
                                                                                                null
                                                                                            "
                                                                                        >
                                                                                            <i
                                                                                                class="fa fa-upload"
                                                                                                aria-hidden="true"
                                                                                            ></i>
                                                                                            Replace
                                                                                        </h3>
                                                                                        <h3
                                                                                            class="dropzone-custom-title"
                                                                                            v-else
                                                                                        >
                                                                                            <i
                                                                                                class="fa fa-upload"
                                                                                                aria-hidden="true"
                                                                                            ></i>
                                                                                            Drag
                                                                                            and
                                                                                            drop
                                                                                            to
                                                                                            upload
                                                                                            content!
                                                                                        </h3>
                                                                                    </div>
                                                                                </vue-dropzone>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <a
                                                                            href="javascript:void(0)"
                                                                            v-if="
                                                                                (getUser !=
                                                                                    null &&
                                                                                    getUser.user_type ==
                                                                                        1) ||
                                                                                hasRole(
                                                                                    'Admin'
                                                                                ) ||
                                                                                hasPerm(
                                                                                    'delete-sales-order'
                                                                                )
                                                                            "
                                                                            v-on:click="
                                                                                removeOtherAttach(
                                                                                    artworkIndex,
                                                                                    artwork.id
                                                                                )
                                                                            "
                                                                            class="trashBtn"
                                                                            ><i
                                                                                class="ri-delete-bin-6-line"
                                                                            ></i
                                                                        ></a>
                                                                        <a
                                                                            href="javascript:void(0)"
                                                                            v-on:click="
                                                                                addNewOtherAttach()
                                                                            "
                                                                            v-if="
                                                                                isEditMode &&
                                                                                ((getUser !=
                                                                                    null &&
                                                                                    getUser.user_type ==
                                                                                        1) ||
                                                                                    hasRole(
                                                                                        'Admin'
                                                                                    ))
                                                                            "
                                                                            class="addNew1"
                                                                            ><i
                                                                                class="fa fa-plus-circle"
                                                                                aria-hidden="true"
                                                                            ></i
                                                                        ></a>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-else>
                                                                <tr>
                                                                    <td
                                                                        colspan="6"
                                                                    >
                                                                        <a
                                                                            href="javascript:void(0)"
                                                                            v-if="
                                                                                (getUser !=
                                                                                    null &&
                                                                                    getUser.user_type ==
                                                                                        1) ||
                                                                                hasRole(
                                                                                    'Admin'
                                                                                )
                                                                            "
                                                                            @click="
                                                                                addNewOtherAttach()
                                                                            "
                                                                            class="addNew1"
                                                                        >
                                                                            <i
                                                                                class="fa fa-plus-circle"
                                                                                aria-hidden="true"
                                                                            ></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            
                                            </div>
                                            <div class="tab-pane" id="arrow-purchase" role="tabpanel">
                                                <div class="table-responsive table-card mt-0 m-0">
                                                    <table class="table table-bordered align-middle mb-0">
                                                        <thead class="table-light text-muted">
                                                            <tr>
                                                                <th>Vendor PO #</th>
                                                                <th>Created</th>
                                                                <th>Status</th>
                                                                <th>Vendor</th>
                                                                <th>Profit</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-if="order.purchase_orders">
                                                            <tr
                                                                v-for="(
                                                                    po, index
                                                                ) in order.purchase_orders"
                                                            >
                                                                <td>
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'purchaseOrderShow',
                                                                            params: {
                                                                                id: po.id,
                                                                            },
                                                                        }"
                                                                        target="_blank"
                                                                    >
                                                                        {{
                                                                            po.po_number
                                                                        }}
                                                                    </router-link>
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        po.order_date
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        po.purchase_order_status
                                                                            ? po
                                                                                  .purchase_order_status
                                                                                  .name
                                                                            : ""
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <p
                                                                        v-if="
                                                                            po.vendor
                                                                        "
                                                                    >
                                                                        <strong
                                                                            >Vendor
                                                                            Name
                                                                            :
                                                                            <router-link
                                                                                :to="{
                                                                                    name: 'vendorDetails',
                                                                                    params: {
                                                                                        id: po
                                                                                            .vendor
                                                                                            .id,
                                                                                    },
                                                                                }"
                                                                                target="_blank"
                                                                            >
                                                                                {{
                                                                                    po.vendor
                                                                                        ? po
                                                                                              .vendor
                                                                                              .company_name
                                                                                        : ""
                                                                                }}
                                                                            </router-link>
                                                                        </strong>
                                                                    </p>
                                                                    <p
                                                                        v-if="
                                                                            po.vendor
                                                                        "
                                                                    >
                                                                        Address
                                                                        :
                                                                        {{
                                                                            po.vendor
                                                                                ? po
                                                                                      .vendor
                                                                                      .address
                                                                                : ""
                                                                        }}
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    ${{
                                                                        getVendorProfit(
                                                                            po
                                                                        )
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <a
                                                    v-if="
                                                        (getUser != null &&
                                                            getUser.user_type ==
                                                                1) ||
                                                        hasRole('Admin') ||
                                                        hasPerm(
                                                            'add-purchase-order'
                                                        )
                                                    "
                                                    href="javascript:void(0);"
                                                    v-on:click="goToCreatePO"
                                                    class="btn create-btn"
                                                    >Create PO</a
                                                >
                                                </div>
                                            </div>
                                            <div class="tab-pane" id="arrow-quotes" role="tabpanel">
                                                <div class="table-responsive table-card mt-0 m-0">
                                                    <table class="table table-bordered align-middle mb-0">
                                                        <thead class="table-light text-muted">
                                                            <tr>
                                                                <th
                                                                style="
                                                                    width: 110px;">
                                                                Quote Number
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 70px;
                                                                "
                                                            >
                                                                Name
                                                            </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                        v-for="(
                                                            quote, index
                                                        ) in orderQuotes"
                                                    >
                                                        <td>
                                                            <router-link
                                                                :to="{
                                                                    name: 'viewQuote',
                                                                    params: {
                                                                        id: quote.id,
                                                                    },
                                                                }"
                                                                target="_blank"
                                                            >
                                                                #{{
                                                                    quote.quotation_number
                                                                }}
                                                            </router-link>
                                                        </td>
                                                        <td>
                                                            {{
                                                                quote.quote_name
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        v-if="
                                                            orderQuotes.length ==
                                                            0
                                                        "
                                                    >
                                                        <td colspan="2">
                                                            No quotes found!
                                                        </td>
                                                    </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            
                                            <div class="tab-pane" id="arrow-shipment" role="tabpanel">
                                                <OrderShipments
                                                    :order="order"
                                                    :bus="bus"
                                                    :loading="loading"
                                                    :shippingProducts="
                                                        shippingProducts
                                                    "
                                                ></OrderShipments>
                                            </div>
                                            <div class="tab-pane" id="arrow-invoice" role="tabpanel">
                                                <div class="bg-light p-3">
                                                    <div class="form-check mb-2">
                                                    <input
                                                                type="radio"
                                                                class="form-check-input"
                                                                value="Y"
                                                                v-model="
                                                                    order.flag_pre_deposit
                                                                "
                                                                name="optradio"
                                                            />
                                                        
                                                        <label class="form-check-label text-dark" for="flexRadioDefault1">Pre-Deposit required to start work</label>
                                                    </div>
                                                    <div class="form-check">
                                                         <input
                                                                type="radio"
                                                                class="form-check-input"
                                                                value="N"
                                                                v-model="
                                                                    order.flag_pre_deposit
                                                                "
                                                                name="optradio"
                                                            />
                                                        <label class="form-check-label text-dark" for="flexRadioDefault2">Pre-Deposit doesnt NOT required to start work</label>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <div
                                                            class="formSection"
                                                        >
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Pre-Deposit
                                                                    Percentage</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            customerPayment.percentage
                                                                        "
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Pre-Deposit
                                                                    Amount</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            customerPayment.amount
                                                                        "
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Pre-Deposit
                                                                    Paid</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                                    <select
                                                                        class="form-control"
                                                                        v-model="
                                                                            customerPayment.status
                                                                        "
                                                                    >
                                                                        <option>
                                                                            Select
                                                                        </option>
                                                                        <option
                                                                            value="Yes"
                                                                        >
                                                                            Yes
                                                                        </option>
                                                                        <option
                                                                            value="No"
                                                                        >
                                                                            No
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Pre-Deposit
                                                                    Date</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                                    <input
                                                                        type="date"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            customerPayment.payment_date
                                                                        "
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Proof of
                                                                    pre-deposit</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                    style="
                                                                        max-width: 200px;
                                                                        max-height: 200px;
                                                                    "
                                                                >
                                                                    <!--<div class="file-attachment-wrapper">
                                                                        <label for="file-yZqVjS" class="relative invoice-upbtn block leading-tight bg-white hover:bg-gray-100 cursor-pointer inline-flex items-center transition duration-500 ease-in-out group overflow-hidden border-2 w-full rounded-lg border-dashed" wire:loading.class="pointer-events-none" :class="{ 'border-indigo-300': isFocused === true }">

                                                                            <input type="hidden" name="placeholder1" v-model="placeholder1" value="">

                                                                            <input type="file" id="file-yZqVjS" class="absolute inset-0 cursor-pointer opacity-0 text-transparent sr-only" accept="image/jpg,image/jpeg,image/png,application/pdf" :multiple="isMultiple" x-ref="input" x-on:change.prevent="handleFiles" x-on:focus="isFocused = true" x-on:blur="isFocused = false">


                                                                            <div wire:loading.flex="" wire:target="placeholder1" wire:loading.class="w-full">

                                                                                <div class="text-center flex-1 p-1">
                                                                                    <div class="upload-btn">Uploading...</div>
                                                                                    <div>
                                                                                        <div class="h-3 relative max-w-lg mx-auto rounded-full overflow-hidden">
                                                                                            <div class="w-full h-full bg-gray-200 absolute"></div>
                                                                                            <div class="h-full bg-green-500 absolute" x-bind:style="'width:' + progress + '%'" style="width:0%"></div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="flex items-center justify-center flex-1" wire:loading.class="hidden" wire:target="placeholder1">
                                                                                <svg class="h-8 w-8 text-gray-300 group-hover:text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"></rect><path d="M168.001,100.00017v.00341a12.00175,12.00175,0,1,1,0-.00341ZM232,56V200a16.01835,16.01835,0,0,1-16,16H40a16.01835,16.01835,0,0,1-16-16V56A16.01835,16.01835,0,0,1,40,40H216A16.01835,16.01835,0,0,1,232,56Zm-15.9917,108.6936L216,56H40v92.68575L76.68652,112.0002a16.01892,16.01892,0,0,1,22.62793,0L144.001,156.68685l20.68554-20.68658a16.01891,16.01891,0,0,1,22.62793,0Z"></path></svg>

                                                                                <span class="text-gray-600">Add File  </span>
                                                                            </div>
                                                                        </label>


                                                                        <div wire:loading.delay="" wire:loading.flex="" wire:target="removeUpload" wire:loading.class="w-full">
                                                                            <div class="text-sm remove-file bg-red-100 flex-1 text-center rounded">
                                                                                Removing file...
                                                                            </div>
                                                                        </div>


                                                                        <div>
                                                                        </div>
                                                                    </div>-->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>  
                                                    <div class="col-lg-6">
                                                        <h5 class="fw-semibold mt-3">Invoice Details</h5>
                                                        <div class="table-responsive table-card m-0">
                                                            <table class="table table-bordered align-middle mb-0">
                                                                <thead class="table-light text-muted">
                                                                    <tr>
                                                                        <th scope="col">Customer Invoice#</th>
                                                                        <th scope="col">Date</th>
                                                                        <th scope="col">Amount</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <!-- <tr>
                                                                        <td><a href="#" class="fw-medium">#5014</a></td>
                                                                        <td>02/23/2022</td>
                                                                        <td>$1155.00</td>
                                                                    </tr> -->
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-3 col-xxl-2" id="on-right">
                                <div class="card two-tabs">
                                    <ul class="nav nav-tabs nav-justified mb-0" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" data-toggle="tab" href="#base-justified-details" role="tab" aria-selected="false">
                                                Details
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" data-toggle="tab" href="#base-justified-task-label" role="tab" aria-selected="false">
                                                Task & More
                                            </a>
                                        </li>
                                    </ul>
                                    <!-- Tab panes -->
                                    <div class="tab-content">
                                           
                                            <OrderCustomer
                                                :companyWarehouse="companyWarehouse"
                                                :order="order"
                                                :loading="loading"
                                                @updatedShippingEvent="updatedShippingEvent"
                                                @updatedCustomerEvent="updatedCustomerEvent"
                                            ></OrderCustomer>
                                            
                                            
                                            
                                            
                                    
                                        <div class="tab-pane" id="base-justified-task-label" role="tabpanel">


                                        <OrderTaskNew
                                            :order="order"
                                            :orderQuotes="orderQuotes"
                                            :loading="loading"
                                            :bus="bus"
                                            @openTaskEditEvent="openTaskEditEvent"
                                            @sendToCustomerEvent="sendToCustomerEvent"
                                            @artworkSampleRequiredEvent="
                                                artworkSampleRequiredEvent
                                            "
                                            @editModeEvent="changeEditMode(true)"
                                            @updatedTaskEvent="updatedTaskEvent"
                                            @sampleShippedEvent="sampleShipped"
                                            @openGetAReadyDateEvent="
                                                openGetAReadyDateEvent
                                            "
                                        ></OrderTaskNew>

                                            
                                            
                                            
                                        </div>
                                    </div>
                                </div>







                                <div class="card she" v-if="isEditMode">


                                    <div class="card-header">
                                       <div class="d-flex justify-content-between align-items-center">
                                            <h5 class="card-title flex-grow-1 mb-0">Artwork/Deposit/Sample Required?</h5>
                                       </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="form-check mb-2">
                                        <input
                                                            v-model="
                                                                order.is_artwork_required
                                                            "
                                                            name="is_artwork_required"
                                                            type="checkbox"
                                                            class="form-check-input"
                                                        />
                                            
                                            <label class="form-check-label" for="formCheck1">
                                                Is artwork required?
                                            </label>
                                        </div>
                                        
                                        <div class="form-check mb-2">
                                        <input
                                                            v-model="
                                                                order.is_deposit_required
                                                            "
                                                            name="is_deposit_required"
                                                            type="checkbox"
                                                            class="form-check-input"
                                                        />
                                            
                                            <label class="form-check-label" for="formCheck1">
                                                Is deposit required?
                                            </label>
                                        </div>

                                        <div class="form-check mb-2">
                                        <input
                                                            v-model="
                                                                order.is_no_artwork
                                                            "
                                                            type="checkbox"
                                                            class="form-check-input"
                                                        />
                                            
                                            <label class="form-check-label" for="formCheck1">
                                                Is sample required?
                                            </label>
                                        </div>

                                        <div class="form-check mb-2">
                                        <input
                                                            v-model="
                                                                order.is_no_artwork
                                                            "
                                                            type="checkbox"
                                                            class="form-check-input"
                                                        />
                                            
                                            <label class="form-check-label" for="formCheck1">
                                                No Artwork
                                            </label>
                                        </div>
                                        <div class="form-check mb-2">
                                        <input
                                                            v-model="
                                                                order.is_repeat_order
                                                            "
                                                            type="checkbox"
                                                            class="form-check-input"
                                                        />
                                            
                                            <label class="form-check-label" for="formCheck1">
                                                Repeat Order
                                            </label>
                                        </div>

                                    </div>


                                </div>



                                



                                


                            </div>
                        </div>

                        <div class="pb-1 mb-3 she custom-btn-align" v-if="isEditMode">


                                <!-- <button class="btn btn-primary w-md" id="edit-cancel">Cancel</button> -->
                                <!-- <button class="btn btn-success w-md">Save</button> -->

                                <button
                                v-if="isEditMode"
                                type="button"
                                :disabled="loading"
                                class="btn btn-primary w-md"
                                @click="
                                    isEditMode = false;
                                    getOrder();
                                "
                            >
                                Cancel
                            </button>

                                <button
                                v-if="isEditMode"
                                type="submit"
                                :disabled="loading"
                                class="btn btn-success w-md"
                            >
                                Save
                            </button>

                            </div>
            </form>
        </ValidationObserver>

        <!-- The Modal -->
        <div class="modal fade custom-right-modal" id="notesModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title card-title">Add Note</h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        <form>
                            <div v-if="noteMessage">
                                <div class="alert alert-success">
                                    {{ noteMessage }}
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="exampleFormControlInput1"
                                    >Description</label
                                >
                                <textarea
                                    row="15"
                                    class="form-control"
                                    id="exampleFormControlInput1"
                                    placeholder=""
                                    v-model="order_note"
                                ></textarea>
                            </div>
                            <button
                                type="button"
                                :class="[loading ? 'disabled' : '']"
                                v-on:click="saveOrderNote()"
                                class="btn btn-primary close-modal"
                            >
                                Submit
                            </button>
                            <hr />
                        </form>
                        <div class="new-noteAdd" v-if="order.order_notes">
                            <div
                                class="task-bg"
                                v-for="(note, index) in order.order_notes"
                            >
                                <div class="small-heading">
                                    {{ note.description }}
                                </div>
                                <span class="pull-right lght-clr"
                                    ><i
                                        class="ri-calendar-event-fill me-1 align-bottom"
                                    ></i>
                                    {{ note.created_at }}</span
                                >

                                <div class="modal-footer-sec">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <div class="light-clr">
                                                Created By
                                                {{
                                                    note.added_by
                                                        ? note.added_by.name
                                                        : ""
                                                }}
                                            </div>
                                        </div>
                                        <div class="flex-shrink-0">
                                            <a href="#" style="font-size: 18px"
                                                ><i
                                                    class="ri-edit-box-line me-1"
                                                ></i
                                            ></a>
                                            <a
                                                href="#"
                                                class="text-danger"
                                                style="font-size: 18px"
                                                ><i
                                                    class="ri-delete-bin-6-line"
                                                ></i
                                            ></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="order.order_notes.length == 0"
                                class="modal-body note-no"
                            >
                                <center>No Note found</center>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>

        <div class="modal fade custom-right-modal" id="actionLogModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">History</h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="history-d" v-if="order.histories">
                            <div
                                class="task-bg"
                                v-for="(history, index) in order.histories"
                            >
                                <div class="small-heading">
                                    {{ strip_html_tags(history.details) }}
                                </div>
                                <div class="small-heading">
                                    {{ strip_html_tags(history.comments) }}
                                </div>
                                <!-- <span class="pull-right lght-clr"
                                    >{{ history.created_at_date }}
                                    {{ history.created_at_time }}</span
                                > -->
                                <!-- <div class="row">
                                    <div class="col-md-12">
                                        <div class="light-clr">
                                            Created By
                                            {{
                                                history.added_by
                                                    ? history.added_by.name
                                                    : ""
                                            }}
                                        </div>
                                    </div>
                                </div> -->

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="light-clr">Created By</div>
                                        <p class="number">{{
                                                history.added_by
                                                    ? history.added_by.name
                                                    : ""
                                            }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="light-clr">Updated Time</div>
                                        <p class="number">{{ history.created_at_date }}
                                    {{ history.created_at_time }}</p>
                                    </div>
                                </div>

                            </div>
                            <div
                                v-if="order.histories.length == 0"
                                class="modal-body note-no"
                            >
                                <center>No records found</center>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>

        <AddTask
            :task="task"
            :bus="bus"
            @addedEvent="taskAddedEvent"
            @updatedEvent="taskUpdatedEvent"
            @completedEvent="completedEvent"
        ></AddTask>
        <SendOrderToCustomer
            :order="order"
            :customer_contact="customer_contact"
            @customerEmailSentEvent="customerEmailSentEvent"
        ></SendOrderToCustomer>
        <OrderDiscountModal
            :order="order"
            :sub_total_cost="sub_total_cost"
            @discountUpdated="discountUpdated"
        ></OrderDiscountModal>
        <OrderExtraChargeModal
            :order="order"
            :sub_total_cost="sub_total_cost"
            :charge="charge"
            :bus="bus"
            ref="orderExtraCharge"
            @extraChargeUpdated="extraChargeUpdated"
        ></OrderExtraChargeModal>
        <ProductArtworksModal
            :order="order"
            :product="product"
            :artwork_statuses="artwork_statuses"
            @productArtworksUpdated="productArtworksUpdated"
            @openSendArtworkToCustomer="openSendArtworkToCustomer"
            @imagePreview="imagePreview"
            @openViewComments="viewComments"
            @openSendArtworkToVendor="openSendArtworkToVendor"
        ></ProductArtworksModal>

        <SelectProductsModal
            :order="order"
            :quantityUnits="quantityUnits"
            :isNewProductsModal="isNewProductsModal"
            :exclude_products="selectedProducts"
            @selectProducts="selectProducts"
        ></SelectProductsModal>
        <ProductArtworkVersionsModal
            :order="order"
            :product="product"
            @imagePreview="imagePreview"
        ></ProductArtworkVersionsModal>
        <AllProductsArtworkVersionsModal
            :order="order"
        ></AllProductsArtworkVersionsModal>
        <SendProductArtworkToCustomer
            :order="order"
            :product="product"
            :artwork="artwork"
            :is_one_artwork_for_all="is_one_artwork_for_all"
            :po="null"
            :customer_contact="customer_contact"
            @sendProductArtworkToCustomerEvent="vendorEmailSentEvent"
        ></SendProductArtworkToCustomer>

        <LightBox
            :media="previewMedia"
            :showLightBox="false"
            :showThumbs="false"
            ref="lightbox"
        ></LightBox>

        <ArtworkCommentModal
            :order="order"
            :artwork="targetArtwork"
            :is_edit="false"
        ></ArtworkCommentModal>

        <SendProductArtworkToVendor
            :order="order"
            :product="product"
            :artwork="artwork"
            :is_one_artwork_for_all="is_one_artwork_for_all"
            @vendorEmailSentEvent="vendorEmailSentEvent"
        ></SendProductArtworkToVendor>
        <!--<AddShippingModal :order="order" :loading="loading" :shipping="shipping" :carriers="carriersState" @addedEvent="shippingAddedEvent" @updatedEvent="shippingUpdatedEvent"></AddShippingModal>-->

        <OrderDatesModal
            v-if="task"
            :task="task"
            :order="task.taskable"
            :orderType="'so'"
            :dateType="dateType"
            @orderDateUpdated="orderDateUpdated"
        ></OrderDatesModal>
        <footer class="footer">
            <div class="dropzone-previews custom-dropzone-preview"></div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">2022 © Superb.</div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>

        <!-- Edit Label Modal -->
                <div class="modal fade" id="editLabelModal" tabindex="-1" aria-labelledby="editLabelModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="editLabelModalLabel">Edit Label</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                            </div>
                            <div class="modal-body form-steps">
                                <div class="mb-3">

                                    <select
                                        class="form-select"
                                        v-model="newLabelId"
                                        multiple="true"
                                    >
                                        <option
                                            v-for="item in labels"
                                            :value="item.id"
                                        >
                                            {{ item.name }}
                                        </option>
                                    </select>

                                    
                                </div>

                                <div class="mt-3 text-end">
                                    <button class="btn btn-primary me-1 w-md"
                                    @click="saveLabelData"
                                    :disabled="newLabelId == null"
                                    >Save
                                    </button>
                                    <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Edit Label Modal -->


                <div class="modal fade" id="editSalesOrderDetailsModal" tabindex="-1" aria-labelledby="editSalesOrderDetailsModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="editSalesOrderDetailsModalLabel">Edit Order Details</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                                
                            </div>
                            <div class="modal-body form-steps">
                            <ValidationObserver v-slot="{ handleSubmit }" ref="formValidationEdit">
                            <form
                                @submit.prevent="handleSubmit(submitHandlerEdit)"
                                enctype="multipart/form-data"
                            >

                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <label>Status</label>
                                        <div>
                                        <select
                                            class="form-select"
                                            v-model="
                                                order.so_status_id
                                            "
                                        >
                                            <option
                                                :value="null"
                                            >
                                                Select
                                            </option>
                                            <option
                                                v-for="(
                                                    status,
                                                    index
                                                ) in statuses"
                                                :value="
                                                    status.id
                                                "
                                            >
                                                {{
                                                    status.name
                                                }}
                                            </option>
                                        </select>

                                            
                                        </div>
                                    </div>

                                    <div class="col-6 mb-3">
                                        <label>Sales Rep</label>
                                        <div>
                                        
                                        <ValidationProvider
                                                        name="Sales Rep"
                                                        rules="required"
                                                        v-slot="{ errors }"
                                                    >
                                                        <select
                                                            
                                                            class="form-control"
                                                            v-model="
                                                                order.sales_rep_id
                                                            "
                                                        >
                                                            <option
                                                                :value="null"
                                                            >
                                                                Select
                                                            </option>
                                                            <option
                                                                v-for="(
                                                                    salesRep,
                                                                    index
                                                                ) in salesReps"
                                                                :value="
                                                                    salesRep.id
                                                                "
                                                            >
                                                                {{
                                                                    salesRep.name
                                                                }}
                                                            </option>
                                                        </select>
                                                        <div
                                                            class="error"
                                                            v-if="errors.length"
                                                        >
                                                            {{ errors[0] }}
                                                        </div>
                                                    </ValidationProvider>

                                            
                                        </div>
                                    </div>

                                    <div class="col-6 mb-3">
                                        <label>SO Number</label>
                                        <input type="" v-model="order.order_number" name="" class="form-control" >
                                    </div>

                                   

                                    <div class="col-6 mb-3">
                                        <label>Created</label>
                                        <ValidationProvider
                                                    name="Created Date"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                >
                                                    <date-picker
                                                        v-model="
                                                            order.order_date
                                                        "
                                                        format="MM/DD/YYYY"
                                                        valueType="format"
                                                    ></date-picker>
                                                    <div
                                                        class="error"
                                                        v-if="errors.length"
                                                    >
                                                        {{ errors[0] }}
                                                    </div>
                                                </ValidationProvider>
                                        
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Customer PO</label>
                                        <input type="" v-model="order.customer_po" name="" class="form-control">
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Customer Terms</label>
                                        <input type="" v-model="order.customer_terms" name="" class="form-control" >
                                    </div>

                                    <div class="col-6 mb-3">
                                        <label>Planned Delivery Date</label>
                                        <ValidationProvider
                                                    name="ETA"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                >
                                                    <date-picker
                                                        v-model="order.eta"
                                                        format="MM/DD/YYYY"
                                                        valueType="format"
                                                    ></date-picker>
                                                    <div
                                                        class="error"
                                                        v-if="errors.length"
                                                    >
                                                        {{ errors[0] }}
                                                    </div>
                                                </ValidationProvider>
                                    </div>

                                    
                                    <div class="col-6 mb-3">
                                        <label>FOB</label>
                                        <input type="" v-model="order.fob" name="" class="form-control" >
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Added By</label>
                                        <div>
                                        <!-- <select
                                            class="form-control"
                                            v-model="newAdminId"
                                        >
                                            <option
                                                v-for="item in admin_users"
                                                :value="item.id"
                                            >
                                                {{ item.name }}
                                            </option>
                                        </select> -->

                                        <select
                                            class="form-control"
                                            v-model="order.added_by.id"
                                        >
                                            <option
                                                v-for="item in admin_users"
                                                :value="item.id"
                                            >
                                                {{ item.name }}
                                            </option>
                                        </select>

                                            
                                        </div>
                                    </div>
                                     <div class="col-6 mb-3">
                                        <label>Quote Number</label>
                                        <input type="" v-model="order.quote_num" name="" class="form-control" >
                                    </div>
                                </div>

                                <div class="mt-3 text-end">
                                    <button class="btn btn-primary me-1 w-md" type="submit">Save</button>
                                    
                                    <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>

                                </form>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </div>


    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import vue2Dropzone from "vue2-dropzone";
//import vue2Dropzone from '../../components/vue-dropzone';
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import SendOrderToCustomer from "../../components/SendOrderToCustomer";
import OrderDiscountModal from "../../components/OrderDiscountModal";
import OrderExtraChargeModal from "../../components/OrderExtraChargeModal";
import ProductArtworksModal from "../../components/ProductArtworksModal";
import SelectProductsModal from "../../components/SelectProductsModal";
import Vue from "vue";
import {
    ValidationProvider,
    ValidationObserver,
    extend,
    configure,
} from "vee-validate";
import ProductArtworkVersionsModal from "../../components/ProductArtworkVersionsModal";
import SendProductArtworkToCustomer from "../../components/SendProductArtworkToCustomer";
//import LightBox from 'vue-image-lightbox';
import LightBox from "vue-it-bigger";
import draggable from "vuedraggable";
import OrderCustomer from "../../components/OrderCustomer";
import ArtworkCommentModal from "../../components/ArtworkCommentModal";
import SendProductArtworkToVendor from "../../components/SendProductArtworkToVendor";
import AllProductsArtworkVersionsModal from "../../components/AllProductsArtworkVersionsModal";
import { VueEditor } from "vue2-editor";
import OrderTask from "../../components/OrderTask";
import OrderTaskNew from "../../components/OrderTaskNew";
import AddShippingModal from "../../components/AddShippingModal";
import AddTask from "../../components/AddTask";
import OrderShipments from "../../components/OrderShipments";
import OrderDatesModal from "../../components/OrderDatesModal";
import AddWarehouse from "../../components/AddWarehouse";

configure({
    classes: {
        valid: "is-valid",
        invalid: "is-invalid",
        dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
        // ...
    },
});

extend("positive", (value) => {
    if (value >= 0) {
        return true;
    }

    return "This field must be a positive number";
});

export default {
    name: "Order",
    components: {
        DatePicker,
        vueDropzone: vue2Dropzone,
        draggable,
        SendOrderToCustomer,
        OrderDiscountModal,
        OrderExtraChargeModal,
        ProductArtworksModal,
        SelectProductsModal,
        ValidationObserver,
        ValidationProvider,
        ProductArtworkVersionsModal,
        SendProductArtworkToCustomer,
        LightBox,
        OrderCustomer,
        ArtworkCommentModal,
        SendProductArtworkToVendor,
        AllProductsArtworkVersionsModal,
        VueEditor,
        OrderTask,
        AddShippingModal,
        AddTask,
        OrderShipments,
        OrderDatesModal,
        AddWarehouse,
        OrderTaskNew
    },
    created() {
        this.getOrderStatuses();
        this.getSalesRep();
        this.getQuantityUnits();
        this.getOrder();
        this.getOrderQuotations();
    },
    mounted() {
    
        let self = this;
        $("#artworkCommentModal").on("hidden.bs.modal", function () {
            self.targetArtwork = null;
        });
        $("#addShippingModal").on("hidden.bs.modal", function () {
            self.shipping = null;
        });
        $("#addTaskModal").on("hidden.bs.modal", function () {
            self.task = null;
        });
        $("#orderDatesModal").on("hidden.bs.modal", function () {
            self.task = null;
        });
        this.getDueTasks();
        this.getShippings();
    },
    data() {
        return {
            companyWarehouse:[],
            customerWarehouse:[],
            bus: new Vue(),
            task: null,
            order: null,
            customer: null,
            customer_contact: null,
            charge: null,
            product: null,
            artwork: null,
            isEditMode: false,
            statuses: [],
            salesReps: [],
            quantityUnits: [],
            vendorSearch: null,
            customerSearch: null,
            customerPayment: {
                payment_date: null,
                status: null,
                amount: null,
                percentage: null,
            },
            attachments: [],
            customerAttachments: [],
            submitted: false,
            sub_total_cost: 0,
            dropzoneOptions: {
                url: window.route("medias.store"),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                //acceptedFiles: 'image/*',
                disablePreviews: true,
                previewsContainer: ".custom-dropzone-preview",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "X-CSRF-TOKEN":
                        document.head.querySelector("[name=csrf-token]")
                            .content,
                },
            },
            dropzoneOptionsArtwork: {
                url: window.route("medias.store"),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                acceptedFiles: "image/*,application/pdf",
                disablePreviews: true,
                previewsContainer: ".custom-dropzone-preview",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "X-CSRF-TOKEN":
                        document.head.querySelector("[name=csrf-token]")
                            .content,
                },
            },
            dropzoneOptionsOriginalFile: {
                url: window.route("medias.store"),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                disablePreviews: true,
                previewsContainer: ".custom-dropzone-preview",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "X-CSRF-TOKEN":
                        document.head.querySelector("[name=csrf-token]")
                            .content,
                },
            },
            noteMessage: null,
            order_note: null,
            purchase_orders: [],
            selectedProducts: [],
            isNewProductsModal: false,
            editorConfig: {},
            editorConfigMin: {
                toolbar: [
                    //["Source", "-", "Bold", "Italic"],
                    //["Styles", "Format", "Font", "FontSize"],
                ],
            },
            artwork_statuses: [],
            previewMedia: [],
            productExtendedView: false,
            eachProductsHasArtwork: false,
            is_one_artwork_for_all: false,
            targetArtwork: null,
            orderQuotes: [],
            isChangeStatusForAllArtworks: true,
            admin_users: [],
            labels: [],
            dueTasks: [],
            poWithTasks: [],
            isEditAddedBySection: false,
            isEditLabelSection: false,
            newAdminId: null,
            newLabelId: [],
            toggleItemsInArtworkSection: false,
            shipping: null,
            shippingProducts: null,
            shippingProductDetailId: null,
            dateType: "eta",
            isPartial: false,
            validationErrors: null,
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
            "setNewPurchaseOrder",
            "setNewOrder",
        ]),
        getTotalShippingQty (product) {
            if (!product || !product.shippings) {
            return 0
            }

            return product.shippings.reduce((total, shipping) => {
            return total + (shipping.pivot ? Number(shipping.pivot.quantity) : 0)
            }, 0)
        },
        
        strip_html_tags(str) {
            // Check if the input string is null or empty
           /* if ((str === null) || (str === '')) {
                // If so, return false
                return str;
            } else {
                // If not, convert the input string to a string type
                str = str.toString();
            }
            // Use a regular expression to replace all HTML tags with an empty string
            return str.replace(/<[^>]*>/g, '');*/

           if (!str) return '';
            const div = document.createElement('div');
            div.innerHTML = str;
            return div.textContent || div.innerText || '';

        },
        isNumber(val) {
            return !isNaN(parseFloat(val)) && isFinite(val);
        },
        imagePreview1(src) {
            let url = window.route("medias.view", {
                path: "so_attachments",
                id: this.order.id,
                name: src,
            });
            this.previewMedia = [
                {
                    thumb: url,
                    src: url,
                    caption: "", // Optional
                    //srcset: '...' // Optional for displaying responsive images
                },
            ];
            this.$refs.lightbox.showImage(0);
        },
        getFileIconForAttachment(attachment) {
            // ri-folder-zip-line, ri-file-ppt-2-line, bx bxs-file-pdf, bx bxs-file-doc, bx bx-image-alt
            //console.log(attachment.file_name.toLowerCase())
            if(attachment.attach_link.toLowerCase().includes(".pdf")) {
                return 'fas fa-file-pdf';
            } else if(attachment.attach_link.toLowerCase().includes(".doc")) {
                return 'fas fa-file-word';
            } else if(attachment.attach_link.toLowerCase().includes(".docx")) {
                return 'fas fa-file-word';
            } else if(attachment.attach_link.toLowerCase().includes(".xlx")) {
                return 'fas fa-file-word';
            } else if(attachment.attach_link.toLowerCase().includes(".xlsx")) {
                return 'fas fa-file-word';
            } else if(attachment.attach_link.toLowerCase().includes(".ppt")) {
                return 'ri-file-ppt-2-line';
            } else if(attachment.attach_link.toLowerCase().includes(".pptx")) {
                return 'ri-file-ppt-2-line';
            } else if(attachment.attach_link.toLowerCase().includes(".zip") || attachment.attach_link.toLowerCase().includes(".rar") ||
                attachment.attach_link.toLowerCase().includes(".7z") || attachment.attach_link.toLowerCase().includes(".gzip") ||
                attachment.attach_link.toLowerCase().includes(".gz")) {
                return 'ri-folder-zip-line';
            } else {
                return 'fas fa-file-image';
            }
        },
        getCustomerWarehouse() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("getWarehouses.customer", {customer_id:this.order.order.customer_id}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerWarehouse = data.data;
                         console.log("customer warehouse ",data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

        getCompanyWarehouse() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("getWarehouses.company", {}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        console.log("company warehouse ",data);
                        this.companyWarehouse = data.data;
                        //this.statuses = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        orderDateUpdated() {
            this.task = null;
            setTimeout(() => {
                $("#orderDatesModal").modal("hide");
            }, 100);
        },
        openGetAReadyDateEvent(event) {
            this.openGetAReadyDate(event.task, event.dateType);
        },
        openGetAReadyDate(task, dateType = "eta") {
            this.task = _.cloneDeep(task);
            this.dateType = dateType;
            setTimeout(() => {
                $("#orderDatesModal").modal("show");
            }, 100);
        },
        sampleShipped(task) {
            task.sample_tracking_no = this.order.sample_tracking_no;
            task.assign_ids = task.admins.map((x) => x.id);
            task.order_id = this.order.id;
            task.order_type = "so";
            task.status = 1;

            let self = this;
            return axios
                .put(
                    window.route("dashboard.tasks.update", { id: task.id }),
                    task,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && Object.keys(data.errors).length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.saveOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
            //this.completeTask(task.id);
        },
        completeTask(id) {
            this.bus.$emit("triggerCompleteTask", id);
        },
        completedEvent() {
            this.bus.$emit("triggerGetTasks");
            this.getDueTasks();
        },
        openTaskEditEvent(task) {
            this.task = _.cloneDeep(task);
            setTimeout(() => {
                $("#addTaskModal").modal("show");
            }, 100);
        },
        taskAddedEvent(event) {
            this.bus.$emit("triggerGetTasks");
            $("#addTaskModal").modal("hide");
        },
        taskUpdatedEvent(event) {
            this.task = null;
            this.bus.$emit("triggerGetTasks");
            $("#addTaskModal").modal("hide");
        },
        openCreateShipment(mode) {
            this.$refs.shipmentRef.click();

            $("#addShippingModal").modal("show");
        },
        toggleShippingProductDetailId(product) {
            if (this.shippingProductDetailId === product.id) {
                this.shippingProductDetailId = null;
            } else {
                this.shippingProductDetailId = product.id;
            }
        },
        getShippingQuantityByStatus(product, status) {
            let total = 0;
            if (status) {
                product.shippings
                    .filter((x) => x.status === status)
                    .forEach((x) => {
                        total += x.pivot.quantity;
                    });
            } else {
                product.shippings.forEach((x) => {
                    total += x.pivot.quantity;
                });
            }

            return total;
        },
        shippingAddedEvent(event) {
            this.getShippings();
            this.getDueTasks();
            this.getOrder();
            this.bus.$emit("triggerGetTasks");
            $("#addShippingModal").modal("hide");
        },
        shippingUpdatedEvent(event) {
            this.shipping = null;
            this.getShippings();
            this.getDueTasks();
            this.getOrder();
            this.bus.$emit("triggerGetTasks");
            $("#addShippingModal").modal("hide");
        },
        getShippings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("getShippings", { id: this.$route.params.id }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.shippingProducts = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        artworkSampleRequiredEvent() {
            //this.changeEditMode(true);
            this.$refs.artworkRef.click();
        },
        sendToCustomerEvent() {
            $("#sendToCustomerModal").modal("show");
        },
        saveAdminData() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("addAdminUser", { id: this.order.id }),
                    { newAdminId: this.newAdminId },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(
                            "Admin user added to this order successfully!"
                        );
                        this.isEditAddedBySection = false;
                        this.newAdminId = null;
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        onAdminDeSelect(event) {},

        saveLabelData() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("so.addLabel", { id: this.order.id }),
                    { newLabelId: this.newLabelId },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(
                            "Label added to this order successfully!"
                        );
                        this.isEditLabelSection = false;
                        $('#editLabelModal').modal('hide');
                        //this.newLabelId = [];
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getDueTasks() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let url = window.route("orders.tasks.due", {
                id: this.$route.params.id,
            });

            return axios
                .get(url, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.dueTasks = _.cloneDeep(data.data);
                        this.poWithTasks = _.cloneDeep(data.poWithTasks);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        handleSortChange(event) {
            //this.saveOrder();
        },
        checkIfFirstRow(product, index, artwork, artworkIndex) {
            if (!product.latest_artwork) {
                return artworkIndex == 0;
            }
            let arts = product.artworks.filter(
                (art) =>
                    art.id == null ||
                    (product.latest_artwork &&
                        art.id == product.latest_artwork.id)
            );
            if (arts.length) {
                return arts[0].id != null && artwork.id == arts[0].id;
            }
            return false;
        },
        artworkStatusChangeForAll(event) {
            //console.log(event, event.target.value)
            if (event.target.value) {
                this.order.products.forEach((product, index) => {
                    if (
                        product.latest_artwork &&
                        !this.isChangeStatusForAllArtworks
                    ) {
                        product.artworks
                            .filter(
                                (x) =>
                                    x.id == null ||
                                    x.id == product.latest_artwork.id
                            )
                            .forEach((artwork, artworkIndex) => {
                                artwork.artwork_status_id = event.target.value;
                            });
                    } else {
                        product.artworks.forEach((artwork, artworkIndex) => {
                            artwork.artwork_status_id = event.target.value;
                        });
                    }
                });
            }
        },
        viewComments(artwork) {
            this.targetArtwork = _.cloneDeep(artwork);
            setTimeout(() => {
                $("#artworkCommentModal").modal("show");
            }, 100);
        },
        vendorEmailSentEvent(event) {
            this.getOrder();
            this.bus.$emit("triggerGetTasks");
        },
        customerEmailSentEvent(event) {
            this.getOrder();
            this.bus.$emit("triggerGetTasks");
        },
        imagePreview(src) {
            let url = window.route("medias.view", {
                path: "so_attachments",
                id: this.order.id,
                name: src,
            });
            this.previewMedia = [
                {
                    thumb: url,
                    src: url,
                    caption: "", // Optional
                    //srcset: '...' // Optional for displaying responsive images
                },
            ];
            this.$refs.lightbox.showImage(0);
        },
        openSendArtworkToVendor(product) {
            this.product = _.cloneDeep(product);
            this.is_one_artwork_for_all = false;
            setTimeout(() => {
                $("#sendProductArtworkToVendor").modal("show");
            }, 50);
        },

        openSendAllArtworkToVendor() {
            this.product = null;
            this.artwork = null;
            this.is_one_artwork_for_all = true;
            $("#sendProductArtworkToVendor").modal("show");
        },
        openSendArtworkToCustomer(product, artwork) {
            this.product = _.cloneDeep(product);
            this.artwork = _.cloneDeep(artwork);
            this.is_one_artwork_for_all = false;
            $("#sendProductArtworkToCustomer").modal("show");
        },
        openSendAllArtworkToCustomer(is_one_artwork_for_all) {
            this.product = null;
            this.artwork = null;
            this.is_one_artwork_for_all = is_one_artwork_for_all;
            $("#sendProductArtworkToCustomer").modal("show");
        },
        addNewProductsFromCustomer() {
            let newOrder = {
                id: this.order.id,
                is_draft: this.order.is_draft,
                is_stocking: this.order.is_stocking,
                stocking_terms: this.order.stocking_terms,
                warehouses: this.order.warehouses,
                customerWarehouses: this.order.customer_warehouses,
                customer_id: this.order.customer_id,
                sales_rep_id: this.order.sales_rep_id,
                order_number: this.order.order_number,
                order_date: this.order.order_date,
                customer_terms: this.order.customer_terms,
                customer_po: this.order.customer_po,
                eta: this.order.eta,
                fob: this.order.fob,
                notes: this.order.notes,
                quotations: [],
                customer: this.customer,
                products: [],
                selectedProducts: [],
            };

            this.setNewOrder(newOrder);
            this.$router.push({ name: "selectQuotes" });
        },
        selectProducts(event) {
            if (event.products && event.products.length > 0) {
                this.isEditMode = true;
                event.products.forEach((x) => {
                    x.quantity = x.qty;
                    this.order.products.push(_.cloneDeep(x));
                });
            }
            $("#newProductsModal").modal("hide");
            this.isNewProductsModal = false;
        },
        productArtworksUpdated(event) {
            this.getOrder();
        },
        openProductArtworksModal(product) {
            this.product = _.cloneDeep(product);
            $("#productArtworksModal").modal("show");
        },
        openProductArtworkVersionsModal(product) {
            this.product = _.cloneDeep(product);
            $("#productArtworkVersionsModal").modal("show");
        },
        openAllProductsArtworkVersionsModal() {
            $("#allProductsArtworkVersionsModal").modal("show");
        },
        getVendorProfit(po) {
            /*let total = this.getTotal();
            let sub_total_cost = 0;
            if (po.purchase_order_products) {
                po.purchase_order_products.forEach((x) => {
                    if (!isNaN(parseInt(x.price))) {
                        sub_total_cost += parseInt(x.price);
                    }
                });
            }
            total = total - sub_total_cost;
            return total.toFixed(2);*/

            let profit = 0;
            if (po.purchase_order_products) {
                po.purchase_order_products.forEach((x) => {
                    if (!isNaN(parseInt(x.calculated_profit))) {
                        profit += parseInt(x.calculated_profit);
                    }
                });
            }

            return profit.toFixed(2);
        },
        getTotal() {
            let total =
                this.sub_total_cost +
                parseFloat(this.getTotalExtraAmount()) -
                parseFloat(this.getDiscountAmount());
            return total;
        },
        getTotalExtraAmount() {
            let total = 0;
            if (this.order && this.order.charges.length > 0) {
                this.order.charges.forEach((x) => {
                    if (
                        x.quantity != null &&
                        x.quantity != "" &&
                        x.quantity > 0
                    ) {

                        if(this.isNumber(x.quantity)){
                            total += x.amount * x.quantity;
                        }
                        
                        
                    } else {
                        if(this.isNumber(x.quantity)){
                            total += x.amount;
                        }
                        
                    }
                });
            }
            return total;
        },
        editCharge(charge) {
            this.charge = _.cloneDeep(charge);
            //console.log(this.charge)
            this.bus.$emit("setChargeData", charge);
            $("#extraChargeModal").modal("show");
        },
        extraChargeUpdated(event) {
            if (event.oldData) {
                let index = this.order.charges.findIndex(
                    (x) => x.id == event.newData.id
                );
                if (index > -1) {
                    this.order.charges[index] = _.cloneDeep(event.newData);
                }
            } else {
                this.order.charges.push(_.cloneDeep(event.newData));
            }
            this.getOrder();
        },
        discountUpdated(event) {
            this.order.discounts = [_.cloneDeep(event)];
            this.getOrder();
        },
        getDiscountAmount() {
            if (this.order && this.order.discounts.length > 0) {
                if (
                    this.order.discounts[0].isPercentage == "1" ||
                    this.order.discounts[0].isPercentage == 1
                ) {
                    return (
                        (this.sub_total_cost * this.order.discounts[0].amount) /
                        100
                    );
                } else {
                    return this.order.discounts[0].amount;
                }
            }
            return 0;
        },
        saveOrderNote() {
            let self = this;
            this.noteMessage = null;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("orders.notes.store", { id: this.order.id }),
                    {
                        so_id: this.order.id,
                        description: this.order_note,
                    },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.noteMessage = "Note saved successfully";
                        this.order_note = null;
                        self.getOrder();
                        setTimeout(() => {
                            this.noteMessage = null;
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        addNewItem() {},
        removeCharge(id){
            let self = this;
            Vue.$confirm({
                title: "Are you sure?",
                message: "Are you sure you want to delete?",
                button: {
                    yes: "Yes",
                    no: "Cancel",
                },
                callback: (confirm) => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios
                            .delete(
                                window.route("orders.charge.destroy", {
                                    id: id,
                                }),
                                {
                                    validateStatus: function (status) {
                                        return status < 500; // Resolve only if the status code is less than 500
                                    },
                                }
                            )
                            .then(({ data }) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(
                                        "Charge deleted from order!"
                                    );
                                    
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                        this.getOrder();
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(
                                    error.response &&
                                        error.response.errorMessage
                                        ? error.response.errorMessage
                                        : error.message
                                );
                            })
                            .finally(() => {
                                self.setLoading(false);
                            });
                    }
                },
            });
        },
        removeItem(id) {
            let self = this;
            Vue.$confirm({
                title: "Are you sure?",
                message: "Are you sure you want to delete?",
                button: {
                    yes: "Yes",
                    no: "Cancel",
                },
                callback: (confirm) => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios
                            .delete(
                                window.route("orders.products.destroy", {
                                    id: self.order.id,
                                    product_id: id,
                                }),
                                {
                                    validateStatus: function (status) {
                                        return status < 500; // Resolve only if the status code is less than 500
                                    },
                                }
                            )
                            .then(({ data }) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(
                                        "Product deleted from order!"
                                    );
                                    self.order.products.splice(
                                        self.order.products.indexOf(
                                            (x) => x.id == id
                                        ),
                                        1
                                    );
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(
                                    error.response &&
                                        error.response.errorMessage
                                        ? error.response.errorMessage
                                        : error.message
                                );
                            })
                            .finally(() => {
                                self.setLoading(false);
                            });
                    }
                },
            });
        },
        afterAllProductsOriginalFileUploadComplete(file, response) {
            this.order.media = _.cloneDeep(response.data.media);
            this.order.original_media_id = response.data.media.id;
            if (this.order.artworks.length) {
                this.order.artworks[
                    this.order.artworks.length - 1
                ].customer_file_media_id = response.data.media.id;
            } else {
                this.order.artworks.push({
                    id: null,
                    is_approve: 0,
                    attach_link: null,
                    comment: null,
                    updated_at: null,
                    media_id: null,
                    artwork_status_id: 3,
                    customer_file_media_id: response.data.media.id,
                });
            }
            //this.isEditMode = true;
            this.saveOrder();
            if (
                this.$refs.allProductsOriginalFileVueDropzone &&
                this.$refs.allProductsOriginalFileVueDropzone.length
            ) {
                //console.log(this.$refs.allProductsOriginalFileVueDropzone[0])
                //console.log(file)
                this.$refs.allProductsOriginalFileVueDropzone[0].removeAllFiles();
            }
            //this.$refs.allProductsOriginalFileVueDropzone.removeFile(file);
        },
        allProductsOriginalFileUploadError(file, message, xhr) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
            //this.$refs.allProductsOriginalFileVueDropzone.removeFile(file)
        },
        afterItemOriginalFileUploadComplete(file, response, index) {
            this.order.products[index].media = _.cloneDeep(response.data.media);
            this.order.products[index].media_id = response.data.media.id;
            if (this.order.products[index].artworks.length) {
                this.order.products[index].artworks[
                    this.order.products[index].artworks.length - 1
                ].customer_file_media_id = response.data.media.id;
            } else {
                this.order.products[index].artworks.push({
                    id: null,
                    is_approve: 0,
                    attach_link: null,
                    comment: null,
                    updated_at: null,
                    media_id: null,
                    artwork_status_id: 3,
                    customer_file_media_id: response.data.media.id,
                });
            }
            //this.isEditMode = true;
            this.saveOrder();
            //console.log(this.$refs.itemOriginalFileVueDropzones)
            if (
                this.$refs.itemOriginalFileVueDropzones &&
                this.$refs.itemOriginalFileVueDropzones.length
            ) {
                //console.log(this.$refs.itemOriginalFileVueDropzones[0])
                //console.log(file)
                this.$refs.itemOriginalFileVueDropzones[index].removeAllFiles();
            }
            //this.$refs.itemOriginalFileVueDropzones[index].removeFile(file)
        },
        itemOriginalFileUploadError(file, message, xhr, index) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
            //this.$refs.itemOriginalFileVueDropzones[index].removeFile(file)
        },
        dropzoneSendingEvent(index) {
            let dropzoneOptions = _.cloneDeep(this.dropzoneOptions);
            dropzoneOptions.prodIndex = index;
            return dropzoneOptions;
        },
        afterArtworkUploadComplete(file, response, artworkIndex) {
            this.order.attachments[artworkIndex].media = _.cloneDeep(
                response.data.media
            );
            this.order.attachments[artworkIndex].media_id =
                response.data.media.id;
            //this.isEditMode = true;
            this.saveOrder();
            if (
                this.$refs.otherAttachments &&
                this.$refs.otherAttachments.length
            ) {
                //console.log(this.$refs.itemArtworkFileVueDropzones[0])
                //console.log(file)
                this.$refs.otherAttachments[0].removeAllFiles();
            }
            //this.$refs.otherAttachments[artworkIndex].removeFile(file)
        },
        otherAttachmentUploadError(file, message, xhr, artworkIndex) {
            //console.log(file, message, xhr);
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
            //this.$refs.otherAttachments[artworkIndex].removeFile(file)
        },
        allArtworkUploadError(file, message, xhr, artworkIndex) {
            //console.log(file, message, xhr);
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
            //this.$refs.allProductsArtworkFileVueDropzone[artworkIndex].removeFile(file)
        },
        afterAllArtworkUploadComplete(file, response, artworkIndex) {
            this.order.artworks[artworkIndex].media = _.cloneDeep(
                response.data.media
            );
            this.order.artworks[artworkIndex].media_id = response.data.media.id;

            if (this.order.artworks[artworkIndex].id == null) {
                this.order.products.forEach((product, pIndex) => {
                    this.order.products[pIndex].artworks.push({
                        id: null,
                        is_approve: 0,
                        attach_link: null,
                        comment: null,
                        updated_at: null,
                        media_id: response.data.media.id,
                        artwork_status_id: 4,
                    });
                });
            }
            //this.isEditMode = true;
            this.saveOrder();
            if (
                this.$refs.allProductsArtworkFileVueDropzone &&
                this.$refs.allProductsArtworkFileVueDropzone.length
            ) {
                //console.log(this.$refs.allProductsOriginalFileVueDropzone[0])
                //console.log(file)
                this.$refs.allProductsArtworkFileVueDropzone[0].removeAllFiles();
            }
            //this.$refs.allProductsArtworkFileVueDropzone[artworkIndex].removeFile(file);
        },
        afterItemArtworkUploadComplete(file, response, index, artworkIndex) {
            this.order.products[index].artworks[artworkIndex].media =
                _.cloneDeep(response.data.media);
            this.order.products[index].artworks[artworkIndex].media_id =
                response.data.media.id;
            // this.isEditMode = true;
            this.saveOrder();
            if (
                this.$refs.itemArtworkFileVueDropzones &&
                this.$refs.itemArtworkFileVueDropzones.length
            ) {
                //console.log(this.$refs.itemArtworkFileVueDropzones[0])
                //console.log(file)
                this.$refs.itemArtworkFileVueDropzones[index].removeAllFiles();
            }
        },
        itemArtworkUploadError(file, message, xhr, artworkIndex) {
            //console.log(file, message, xhr);
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        addNewItemAttach(index) {
            this.order.products[index].artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null,
                artwork_status_id: 1,
            });
        },
        addNewItemAttachVersion(index) {
            this.order.products[index].artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null,
                artwork_status_id: 1,
            });
            this.isEditMode = true;
        },
        removeItemAttach(index, artworkIndex, product_id, artwork_id = null) {
            if (artwork_id) {
                let self = this;
                Vue.$confirm({
                    title: "Are you sure?",
                    message: "Are you sure you want to delete?",
                    button: {
                        yes: "Yes",
                        no: "Cancel",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            self.setLoading(true);
                            self.setCommonErrors([]);
                            self.setErrorMessage(null);
                            return axios
                                .delete(
                                    window.route(
                                        "orders.products.artworks.destroy",
                                        {
                                            id: self.order.id,
                                            product_id: product_id,
                                            artwork_id: artwork_id,
                                        }
                                    ),
                                    {
                                        validateStatus: function (status) {
                                            return status < 500; // Resolve only if the status code is less than 500
                                        },
                                    }
                                )
                                .then(({ data }) => {
                                    if (data.errorMessage) {
                                        self.setErrorMessage(data.errorMessage);
                                        if (data.errors) {
                                            self.setCommonErrors(data.errors);
                                        }
                                    } else {
                                        self.setSuccessMessage(
                                            "Artwork deleted!"
                                        );
                                        self.order.products[
                                            index
                                        ].artworks.splice(artworkIndex, 1);
                                        if (
                                            self.order.products[index].artworks
                                                .length
                                        ) {
                                            self.order.products[
                                                index
                                            ].latest_artwork = _.cloneDeep(
                                                self.order.products[index]
                                                    .artworks[
                                                    self.order.products[index]
                                                        .artworks.length - 1
                                                ]
                                            );
                                        } else {
                                            self.order.products[
                                                index
                                            ].latest_artwork = null;
                                        }

                                        self.getOrder();
                                        setTimeout(() => {
                                            self.setSuccessMessage(null);
                                        }, 5000);
                                    }
                                })
                                .catch((error) => {
                                    self.setErrorMessage(
                                        error.response &&
                                            error.response.errorMessage
                                            ? error.response.errorMessage
                                            : error.message
                                    );
                                })
                                .finally(() => {
                                    self.setLoading(false);
                                });
                        }
                    },
                });
            } else {
                this.order.products[index].artworks.splice(artworkIndex, 1);
            }
        },
        goToCreateVendor() {},
        addNewAllProductArtwork() {
            this.order.artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null,
                artwork_status_id: 1,
            });
        },
        removeAllProductArtwork(artworkIndex, artwork_id = null) {
            if (artwork_id) {
                let self = this;
                Vue.$confirm({
                    title: "Are you sure?",
                    message: "Are you sure you want to delete?",
                    button: {
                        yes: "Yes",
                        no: "Cancel",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            self.setLoading(true);
                            self.setCommonErrors([]);
                            self.setErrorMessage(null);
                            return axios
                                .delete(
                                    window.route("orders.artworks.destroy", {
                                        id: self.order.id,
                                        artwork_id: artwork_id,
                                    }),
                                    {
                                        validateStatus: function (status) {
                                            return status < 500; // Resolve only if the status code is less than 500
                                        },
                                    }
                                )
                                .then(({ data }) => {
                                    if (data.errorMessage) {
                                        self.setErrorMessage(data.errorMessage);
                                        if (data.errors) {
                                            self.setCommonErrors(data.errors);
                                        }
                                    } else {
                                        self.setSuccessMessage(
                                            "Artwork deleted!"
                                        );
                                        self.order.artworks.splice(
                                            artworkIndex,
                                            1
                                        );
                                        if (self.order.artworks.length) {
                                            self.order.latest_artwork =
                                                _.cloneDeep(
                                                    self.order.artworks[
                                                        self.order.artworks
                                                            .length - 1
                                                    ]
                                                );
                                        } else {
                                            self.order.latest_artwork = null;
                                        }
                                        self.getOrder();
                                        setTimeout(() => {
                                            self.setSuccessMessage(null);
                                        }, 5000);
                                    }
                                })
                                .catch((error) => {
                                    self.setErrorMessage(
                                        error.response &&
                                            error.response.errorMessage
                                            ? error.response.errorMessage
                                            : error.message
                                    );
                                })
                                .finally(() => {
                                    self.setLoading(false);
                                });
                        }
                    },
                });
            } else {
                this.order.artworks.splice(artworkIndex, 1);
            }
        },
        addNewOtherAttach() {
            this.order.attachments.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null,
            });
        },
        removeOtherAttach(artworkIndex, artwork_id = null) {
            if (artwork_id) {
                let self = this;
                Vue.$confirm({
                    title: "Are you sure?",
                    message: "Are you sure you want to delete?",
                    button: {
                        yes: "Yes",
                        no: "Cancel",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            self.setLoading(true);
                            self.setCommonErrors([]);
                            self.setErrorMessage(null);
                            return axios
                                .delete(
                                    window.route("orders.artworks.destroy", {
                                        id: self.order.id,
                                        artwork_id: artwork_id,
                                    }),
                                    {
                                        validateStatus: function (status) {
                                            return status < 500; // Resolve only if the status code is less than 500
                                        },
                                    }
                                )
                                .then(({ data }) => {
                                    if (data.errorMessage) {
                                        self.setErrorMessage(data.errorMessage);
                                        if (data.errors) {
                                            self.setCommonErrors(data.errors);
                                        }
                                    } else {
                                        self.setSuccessMessage(
                                            "Artwork deleted!"
                                        );
                                        self.order.attachments.splice(
                                            artworkIndex,
                                            1
                                        );
                                        self.getOrder();
                                        setTimeout(() => {
                                            self.setSuccessMessage(null);
                                        }, 5000);
                                    }
                                })
                                .catch((error) => {
                                    self.setErrorMessage(
                                        error.response &&
                                            error.response.errorMessage
                                            ? error.response.errorMessage
                                            : error.message
                                    );
                                })
                                .finally(() => {
                                    self.setLoading(false);
                                });
                        }
                    },
                });
            } else {
                this.order.attachments.splice(artworkIndex, 1);
            }
        },
        addNewCustomerAttach() {},
        removeCustomerAttach(id) {},
        submitHandler() {
            /*this.$refs.orderFormValidation.validate().then(success => {
                console.log('success', success)
                if (!success) {
                    return;
                }
                this.saveOrder();
            });*/
            this.$refs.orderFormValidation.validateWithInfo().then((data) => {
                //console.log('success', data.isValid, data.errors, data.flags, data.fields)
                this.validationErrors = data;
                if (!data.isValid) {
                    return;
                }
                this.saveOrder();
            });
        },
        submitHandlerEdit() {
            /*this.$refs.orderFormValidation.validate().then(success => {
                console.log('success', success)
                if (!success) {
                    return;
                }
                this.saveOrder();
            });*/
            this.$refs.formValidationEdit.validateWithInfo().then((data) => {
                //console.log('success', data.isValid, data.errors, data.flags, data.fields)
                this.validationErrors = data;
                if (!data.isValid) {
                    return;
                }
                this.saveOrder();
            });
        },
        saveOrder(e) {
            let self = this;
            this.submitted = true;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .put(
                    window.route("orders.update", { id: this.order.id }),
                    this.order,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        $('#editSalesOrderDetailsModalLabel').modal('hide');
                        $('#editSalesOrderDetailsModal').modal('hide');
                        self.setSuccessMessage("Order saved successfully!");
                        self.isEditMode = false;
                        self.getOrder();
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        createPO() {
            this.goToCreatePO();
            return;

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("orders.createPO", { id: this.order.id }),
                    {},
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        copySoOrder() {
            let newOrder = {
                id: null,
                parent_id: this.order.id,
                is_draft: 0,
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
                customer_id: null,
                sales_rep_id: null,
                order_number: null,
                order_date: null,
                customer_terms: null,
                customer_po: null,
                eta: null,
                fob: null,
                notes: null,
                customer_notes: null,
                quotations: [],
                customer: {
                    quotations_after_sent_to_customer: [],
                },
                products: [],
                selectedProducts: [],
            };
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("orders.clone", { id: this.order.id }),
                    { is_save: false },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        newOrder = data.data.order;
                        this.setNewOrder(newOrder);
                        this.$router.push({ name: "selectCustomer" });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        sendToCustomer() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("orders.sendToCustomer", {
                        id: this.order.id,
                    }),
                    {},
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.getOrder();
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        changeEditMode(mode) {
            this.isEditMode = mode;
        },
        
        getOrder() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(
                    window.route("orders.show", { id: this.$route.params.id }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {



                        console.log("order in order",data);
                        this.isPartial = data.is_partial;
                        this.admin_users = _.cloneDeep(data.admin_users);
                        this.labels = _.cloneDeep(data.labels);
                        data.data.new_admin_users = [];
                        if (data.data.admin_users) {
                            data.data.admin_users.forEach((x) => {
                                data.data.new_admin_users.push(x.admin);
                            });
                        }
                        if (
                            data.data.artworks &&
                            data.data.artworks.length > 0 &&
                            data.data.latest_artwork == null
                        ) {
                            data.data.latest_artwork = _.cloneDeep(
                                data.data.artworks[
                                    data.data.artworks.length - 1
                                ]
                            );
                        }
                        data.data.products.forEach((x) => {
                            if (
                                x.artworks &&
                                x.artworks.length > 0 &&
                                x.latest_artwork == null
                            ) {
                                x.latest_artwork = _.cloneDeep(
                                    x.artworks[x.artworks.length - 1]
                                );
                            }
                        });
                        if (
                            data.data.customer &&
                            data.data.customer.customer_contacts &&
                            data.data.customer.customer_contacts.length > 1
                        ) {
                            data.data.customer.customer_contacts =
                                data.data.customer.customer_contacts.filter(
                                    (x) => x.deleted === '0'
                                );
                        }

                        if (
                            data.customer &&
                            data.customer.customer_contacts &&
                            data.customer.customer_contacts.length > 1
                        ) {
                            data.customer.customer_contacts =
                                data.customer.customer_contacts.filter(
                                    (x) => x.deleted === 0
                                );
                        }

                        this.order = data.data;

                        if(this.order.pdf_note == null || this.order.pdf_note == ''){
                            
                            this.order.pdf_note = data.default_po_pdf_note
                        }
                        
                        this.customer = data.customer;
                        this.customer_contact = _.cloneDeep(
                            data.customer_contact
                        );
                        this.artwork_statuses = data.artwork_statuses;
                        this.newLabelId = [];
                        this.order.labels.forEach((l) => {
                            this.newLabelId.push(l.id);
                        });

                        this.eachProductsHasArtwork = false;

                        this.order.admin_users = [];
                        this.order.order_admins.forEach((admin) => {
                            this.order.admin_users = this.admin_users.filter(
                                (x) => admin.admin_id == x.id
                            );
                        });

                        if (
                            this.order.original_customer_file &&
                            this.order.customer_file_media_id &&
                            this.order.artworks.length == 0
                        ) {
                            this.order.artworks.push({
                                id: null,
                                is_approve: 0,
                                attach_link: null,
                                comment: null,
                                updated_at: null,
                                media_id: null,
                                artwork_status_id: 1,
                                customer_file_media_id:
                                    this.order.customer_file_media_id,
                            });
                        }

                        if (this.order.products) {
                            this.eachProductsHasArtwork =
                                this.order.products.filter(
                                    (x) =>
                                        x.id &&
                                        x.artworks &&
                                        x.artworks.filter(
                                            (y) => y.id && y.attach_link != null
                                        ).length > 0
                                ).length > 0;
                            this.sub_total_cost = 0;
                            this.selectedProducts = [];
                            this.order.products.forEach((x) => {
                                if (
                                    x.original_customer_file &&
                                    x.uploaded_media_id &&
                                    x.artworks.length == 0
                                ) {
                                    x.artworks.push({
                                        id: null,
                                        is_approve: 0,
                                        attach_link: null,
                                        comment: null,
                                        updated_at: null,
                                        media_id: null,
                                        artwork_status_id: 1,
                                        customer_file_media_id:
                                            x.uploaded_media_id,
                                    });
                                }
                                this.selectedProducts.push(x.product_id);
                                if (
                                    !isNaN(parseInt(x.price)) &&
                                    !isNaN(parseInt(x.quantity))
                                ) {
                                    x.cost =
                                        parseInt(x.price) *
                                        parseInt(x.quantity);
                                    this.sub_total_cost += x.cost;
                                }
                                /*if(x.purchase_order_products) {
                                    let po_product_total = 0;
                                    x.purchase_order_products.forEach((pp) => {
                                        if (!isNaN(parseInt(pp.price)) && !isNaN(parseInt(pp.quantity))) {
                                            po_product_total += parseInt(pp.price) * parseInt(pp.quantity);
                                        }
                                    });

                                    x.calculated_profit = x.cost - po_product_total;
                                }*/
                            });
                        }

                        this.sub_total_cost = this.order.amount;

                        this.bus.$emit("triggerGetTasks");
                        this.getCompanyWarehouse();
                       // this.getCustomerWarehouse();
                        this.getDueTasks();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getOrderQuotations() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(
                    window.route("orders.quotations.index", {
                        id: this.$route.params.id,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.orderQuotes = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getOrderStatuses() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("sales-orders-status.index", {}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.statuses = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getSalesRep() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("so.sales_rep"), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.salesReps = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getQuantityUnits() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("so-quantity-units.index"), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.quantityUnits = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        goToCreatePO() {
            let newOrder = {
                order_id: null,
                vendor_id: null,
                vendor_company_name: null,
                is_draft: 0,
                po_number: null,
                order_date: null,
                vendor_terms: null,
                vendor_po: null,
                vendor_fob: null,
                eta: null,
                delivery_date: null,
                notes: null,
                po_status_id: 1,
                products: [],
                selectedProducts: [],
                quote_num: null,
            };
            newOrder.order_id = this.order.id;
            newOrder.vendor_po = this.order.customer_po;

            let orderQuotes = this.orderQuotes.filter(
                (x) =>
                    x.quotation_products &&
                    x.quotation_products.filter(
                        (qp) =>
                            qp.quotation_prices &&
                            qp.quotation_prices.filter((qpp) => qpp.vendor_id)
                                .length
                    ).length > 0
            );

            if(this.order.quote_num != null){
                newOrder.quote_num = this.order.quote_num;
            }
            else if (orderQuotes.length) {
                newOrder.quote_num = orderQuotes[0].quotation_number;
                let quotation_products =
                    orderQuotes[0].quotation_products.filter(
                        (qp) =>
                            qp.quotation_prices &&
                            qp.quotation_prices.filter((qpp) => qpp.vendor_id)
                                .length
                    );
                if (quotation_products.length) {
                    let quotation_prices =
                        quotation_products[0].quotation_prices.filter(
                            (qpp) => qpp.vendor_id
                        );
                    if (quotation_prices.length) {
                        newOrder.vendor_id = quotation_prices[0].vendor_id;
                        newOrder.vendor_company_name =
                            quotation_prices[0].vendor.company_name;
                        newOrder.vendor = quotation_prices[0].vendor;
                        newOrder.vendor_terms =
                            quotation_prices[0].vendor.vendor_terms;
                    }
                }
            }

            this.setNewPurchaseOrder(newOrder);
            this.$router.push({
                name: "purchaseSelectProducts",
                query: { order_id: this.order.id },
            });
        },
        download(artwork) {
            let url = window.route("medias.download", {
                path: "so_attachments",
                id: this.order.id,
                name: artwork.attach_link,
                pdf_to_image: 0,
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(url, {
                    responseType: "blob",
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", artwork.attach_link);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        downloadOriginalArtwork(original_customer_file) {
            let url = window.route("medias.download", {
                path: "so_attachments",
                id: this.order.id,
                name: original_customer_file,
                pdf_to_image: 0,
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(url, {
                    responseType: "blob",
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", original_customer_file);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        downloadPdf() {
            let url = window.route("orders.download", { id: this.order.id });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(url, {
                    responseType: "blob",
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute(
                        "download",
                        "so_" + this.order.order_number + ".pdf"
                    );
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        updatedCustomerEvent() {
            this.getOrder();
        },
        updatedShippingEvent() {
            this.getOrder();
        },
        updatedTaskEvent() {
            this.getOrder();
        },
    },
    watch: {
        "order.products": {
            handler: function (after, before) {
                this.sub_total_cost = 0;
                after.forEach((x, index) => {
                    this.order.products[index].unit_price = x.price;
                    let sum = x.price * x.quantity;
                    if (!isNaN(sum)) {
                        this.order.products[index].cost = sum;
                        this.sub_total_cost += sum;
                    }
                });
            },
            deep: true,
        },
        "order.is_artwork_required": {
            handler: function (after, before) {
                if (after) {
                    this.order.is_no_artwork = false;
                }
            },
        },
        "order.is_no_artwork": {
            handler: function (after, before) {
                if (after) {
                    this.order.is_artwork_required = false;
                }
            },
        },
        /*"order.is_artwork_required": {
            handler: function (after, before) {
                if(after !== before) {
                    this.saveOrder();
                }
            }
        },
        "order.is_deposit_required": {
            handler: function (after, before) {
                if(after !== before) {
                    this.saveOrder();
                }
            }
        },
        "order.is_sample_required": {
            handler: function (after, before) {
                if(after !== before) {
                    this.saveOrder();
                }
            }
        },*/
    },
    computed: {
        ...mapState(["userState"]),
        ...mapGetters([
            "isAuth",
            "getAuthUser",
            "commonErrors",
            "errorMessage",
            "successMessage",
            "loading",
            "carriersState",
        ]),
    },
};
</script>

<style scoped>
.error {
    color: red;
}
.dropzone-previews {
    display: none !important;
}
</style>
